/* ----------------------- AVOID PUTTING CODE IN GLOBAL SCOPE  ----------------------------------- */
$(function () {
    /* ---- BEGIN LOCAL NAMED FUNCTIONS DECLARATION ----*/    
    // Localized variables kept in localizeddetails file
    var selBaseTrim = $('#selectedColorID');
    var catAlias = $('#CatalogAlias').val();
    var isApparelItem = $('.isApparelItem').val();
    var currencySymbol = $('#tdCurrencySymbol').html();
    var quantityTextbox = $('#txtQty').val();
    var nibInkInput = $('#nibInkSelection');
    var adhesiveInput = $('#adhesiveSelection');
    var recolorAvailable = $("#isRecolorable").val();
    var localizedJS = new localizedDetails();
    var steppingQty = parseInt($('#litSteppingQty').val());
    var totalLabel = $('#lblTotal').text();
    var priceLabel = $('#lblPrice').html();
    var quantityTextbox = $('#txtQty').val();
    var reportSKU = $('#ReportSKU').val();
    var ukShippingCost = $('#UKShippingCost').val();
    var ukTaxRate = $('#UKTaxRate').val();
    var baseExtra = $('#BaseExtra').val();
    
    var isMobile = $('.contactPanel').css('display') == 'none';
    var isDesktop = $('.prodNumber').css('float') == 'none';
    var isTabMobile = $('.prodNumber').css('float') == 'left';
    var isTabletDesktop = $(".contactPanel").css("display") == 'block';
    var lastFocus;	
    
	function OmniLogCartAdd(newCart) {
	    if (typeof s != "undefined") {
	        s.events = (newCart) ? 'scOpen, scAdd' : 'scAdd';
	        /************* DO NOT ALTER ANYTHING BELOW THIS LINE ! **************/
	        var s_code = s.t(); if (s_code) document.write(s_code);
	    }
	} 
	
    //center extra images
    function centerExtraImgs() {
    	$('.prodImages').removeClass('hide');
    	if ($('.extraImage').length <= 4){
	     var totalWidth = 0;
	      $('.extraImage').each(function (index) { 
	          totalWidth += parseInt(($(this).width() + 11), 10);
	      });
	      $('.extraImgsBox').css('width', totalWidth);      
	  }
	  else {
	  	$('.extraImgsBox').css('width', '560px');    
	  }
   }//end center extra images
  	
    //check for google feed
    var qryStr = window.location.search;
    qryStr = qryStr.indexOf("gfeed=1");
    function CheckQueryString(){
    	if (qryStr > 0) {
    		var txtQty = '';
		if ($('.isApparelItem').val() == 'False') {
            	txtQty = parseInt($("#txtQty").val());
        	} else { 
            	txtQty = parseInt($("#txtQty").html());
        	} 
		var selBaseTrim = $('.selectedColorID').first().val(); 
		var glideUnitPrice = 0;
		var glideTotal = 0;
		glideUnitPrice = $('#lblPrice').html();
		glideTotal = $('#lblTotal').html();
		
		$('#GFeedQty').html(txtQty);
		$('#GFeedUnitPrice').html(glideUnitPrice);	       
		$('#GFeedTotalPrice').html(glideTotal); 
		SaveImprintColor($('#gFeedDefaultImprintColor').siblings('.spnColorChip'));
		
		if (optionalExtras == null) { LoadOptionalExtras(); }
		if (nibInkOptions == null) { LoadNibInkColor();  }
		if (adhSidesOptions == null) { LoadAdhesiveOptions();  }
		GetExtras($('#GFeedData')); 
		}
    }
    //end google feed
    
    //calculate the width of the reviews, ss, customer photos, q&a, fit rating tabs
    function detailTabWidth(){
    	var isApparel = $('.isApparelItem').val() == 'True';
    	var isNotApparel = $('.isApparelItem').val() == 'False';
    	var isMobile = $('.contactPanel').css('display') == 'none';
    	var isDesktop = $('.prodNumber').css('float') == 'none';
    	var isTabMobile = $('.prodNumber').css('float') == 'left';
    	var isTabletDesktop = $(".contactPanel").css("display") == 'block';
    	var showCustomerImages = localizedJS.showCustomerImages;
	  var w;
        if (isMobile && isNotApparel && showCustomerImages){
            $('#fitRatingTS').hide();
            $('.detailsTabSelect').width(100+'%');
        }
        else if (isMobile && isApparel && showCustomerImages){
            $('.detailsTabSelect').width(100+'%');
        }
        else if (isMobile && isNotApparel){
            $('#customerImagesTS').hide();
            $('#fitRatingTS').hide();
            $('.detailsTabSelect').width(100+'%');
        }
        else if (isMobile){
            $('#customerImagesTS').hide();
            $('.detailsTabSelect').width(100+'%');
        }
        else if (isTabletDesktop && isApparel && showCustomerImages){
            w = (100/5);
            $('.detailsTabSelect').width(w+'%');
        }
        else if (isTabletDesktop && isNotApparel && showCustomerImages){
            $('#fitRatingTS').hide();
            w = (100/4);
            $('.detailsTabSelect').width(w+'%');
        }
        else if (isTabletDesktop && isApparel){
            $('#customerImagesTS').hide();
            w = (100/4);
            $('.detailsTabSelect').width(w+'%');
        }
        else if (isTabletDesktop && isNotApparel){
            $('#customerImagesTS').hide();
            $('#fitRatingTS').hide();
            w = (100/3);
            $('.detailsTabSelect').width(w+'%');
        }
        
        if (isApparel && showCustomerImages) {
        	detailTabResizeText();
        }
    }
    detailTabWidth();
    $(window).resize(detailTabWidth);
    
    //resize text of detail tabs when window is resized (only if product is apparel)
    function detailTabResizeText() {
        if (window.innerWidth >= 1030) {
            $('.detailsTabSelect h2').addClass('text18');
            $('.detailsTabSelect h2').removeClass('text16');
        }
        else if (window.innerWidth >= 600) {
            $('.detailsTabSelect h2').addClass('text16');
            $('.detailsTabSelect h2').removeClass('text18');
        }
        else if (window.innerWidth < 600) {
            $('.detailsTabSelect h2').addClass('text18');
            $('.detailsTabSelect h2').removeClass('text16');
        }
    }
	
    //save product color
    function SaveProdColor(triggerElement) {
        $('.errorMsg').remove();
        var selectedImg = $(triggerElement).attr('src');
        var selectedBaseTrimID = "";
        var selectedColorName = "";
        var trimColorHex = "";
        var baseColorHex = "";
        $("#photoSwipeBox").royalSlider('goTo', 0);
        if (recolorAvailable == "True") {
            $('.imgBox').each(function () {
                $(this).children('.selectedImgDesc').addClass('textDarkestGray').removeClass('bkgdBlue').children('.selectedImgOutOfStockDesc').addClass('textRed').removeClass('textWhite');
                $(this).removeClass('imgActive');
            });

            $(triggerElement).parent().siblings('.selectedImgDesc').addClass('textWhite bkgdBlue').removeClass('textDarkestGray').children('.selectedImgOutOfStockDesc').addClass('textWhite').removeClass('textRed');
            $(triggerElement).parent().parent('.imgBox').addClass('imgActive');
            selectedImg = selectedImg.replace("rend/60", "rend/300");
            $('#hypProdImg .mainProdImg').attr("src", selectedImg);
            
            selectedImg = selectedImg.replace("rend/300", "rend/700");
            cleanJQZoom();
            $('#hypProdImg').attr("href", selectedImg);
            loadJQZoom();
            
            $('#colorSelected').val($(triggerElement).attr("title"));
            selectedBaseTrimID = $(triggerElement).parent().siblings('.selectedColorID').val();
            $('#colorSummary').text($(triggerElement).attr('title'));
            selectedColorName = $(triggerElement).parent().siblings('.selectedColorName').val();
            baseColorHex = $(triggerElement).parent().siblings('.baseColorHex').val();
            trimColorHex = $(triggerElement).parent().siblings('.trimColorHex').val();
        }
        else {
            selectedBaseTrimID = $(triggerElement).children('.selectedColorID').val();
            selectedColorName = $(triggerElement).children(".selectedColorName").val();
            baseColorHex = $(triggerElement).children('.baseColorHex').val();
            trimColorHex = $(triggerElement).children('.trimColorHex').val();

            $('.prodImgSelected').each(function () {
                $(this).children('.selectedImgDesc').addClass('textDarkestGray').removeClass('bkgdBlue').children('.selectedImgOutOfStockDesc').addClass('textRed').removeClass('textWhite');
            });

            $(triggerElement).children('.selectedImgDesc').addClass('textWhite bkgdBlue').removeClass('textDarkestGray').children('.selectedImgOutOfStockDesc').addClass('textWhite').removeClass('textRed');
        }

        $('#baseSpan').css('background-color', '#' + baseColorHex);
        $('#trimSpan').css('background-color', '#' + trimColorHex);

        if (selectedBaseTrimID != undefined && selectedBaseTrimID != "") {
        	$('.CheckMarkProdColor').removeClass('textMdGray');
            $('.CheckMarkProdColor').addClass('textGreen');
            selBaseTrim.val(selectedBaseTrimID);
            $('#colorSelected').val(selectedColorName);
            $('#selColors').html(selectedColorName);
        }

        if ($('.isApparelItem').val() == "False") {
            $('.step1').removeClass('disabledBtn').addClass('bkgdBlue whiteLink');
        }

        if (selectedBaseTrimID != '' && $('.isApparelItem').val() == "True") {
            //Load apparel size grid
            $('#PD_SizeGrid').html('');
            $('#PD_SizeGridLoading').show();
            $('.PD_QuantityBtnCell input').attr('disabled', 'disabled').css('opacity', 0.3);// Disables the qty button to keep it from opening multiple windows
            $('.PD_SizeChoicePanel').fadeIn('fast');//.centerInClient();

            $.ajax({
                url: '/productmvc/loadsizeoptions',
                type: 'POST',
                data: { 'ProductID': prodID, 'Color': selectedBaseTrimID, 'EditID': editID },
                datatype: 'html',
                beforeSend: function () {
                    $('.sizeGridLoadingImg').fadeIn('fast', function () { });
                },
                complete: function () {
                    $('.sizeGridLoadingImg').hide('fast', function () { });
                    CheckQueryString();
                     $('#GFeedPanel').show();
                },
                timeout: 20000,
                success: function (data) {
                    $('#PD_SizeGridLoading').hide(); // Hide the loading image
                    $('#SizingGrid').html(data);
                    RenderToolTips();
                    if(editID < 0 && qryStr > 0){
                    	$('.txtApparelQty').first().val(lowestQty);
                    }
                    CalcPrice();
                },
                error: function () {
                    $('#PD_SizeGridLoading').hide();
                    $('#SizingGrid').html('<div role="alert" class="margin10 padding10 borderDkRed textDkRed">An error occured when looking up the available sizes. Please select ' + localizedJS.Color + ' again, or call us toll free at ' + localizedJS.PhoneNumber + ' for further assistance.</div>');
                }
            });
        }
    }
    //end product color
    
    //show color option window
    function showColorOptions() {
        $('#colorOptions').show();
        $('#colorOptions').attr('aria-hidden', 'false');
        $('#selectBaseColor').show();
        $('#selectBaseColor').attr('aria-hidden', 'false');
        $('#prodColorCountContainer').hide();
        $('#prodColorCountContainer').attr('aria-hidden', 'true');
        $('#productColorScroller').hide();
        $('#productColorScroller').attr('aria-hidden', 'true');
    }
    //end show color options

    //jump to a color
    function jumpToColor(triggerElement, focus) {
        var chosenColorID = '';
        if ($(triggerElement).is('#removeColorFilter')) {
            chosenColorID = '-1';
        }
        else if ($(triggerElement).hasClass('colorOption')) {
            chosenColorID = triggerElement.id.replace('colorOption', '');
        }
        else {
            chosenColorID = triggerElement.parentNode.id.replace('colorOption', '');
        }
	
        $.ajax({
            url: '/product/productcoloroptions',
            type: 'post',
            data: $('form').serialize() + '&chosenColorID=' + chosenColorID,
            success: function (result) {
                $('#productColors').html(result);
                
                colorOptionsClicks();
                initProductColorScroller();
                productColorScrollerSlick();
                
                if (focus) {
                	$('#productColorScroller').find('.imgBox').first().children('.selectedImgDesc').focus();
                }
            }
        });
    }
    //end jump to color
    
    //bind clicks and keypresses for product color options
    function colorOptionsClicks() {
        $('#jumpToColor').click(function() { showColorOptions(); });
        $('#jumpToColor').keypress(function (e) {
            if (e.which == 13) {
                $(this).click();
                $('#colorOptions').find('.colorOption').first().focus();
            }
        });
        
        $('.colorOption').click(function() { jumpToColor(this, false); });
        $('.colorOption').keypress(function (e) {
            if (e.which == 13) {
                jumpToColor(this, true);
            }
        });
        
        $('#removeColorFilter').click(function() { jumpToColor(this, false); });
        $('#removeColorFilter').keypress(function (e) {
            if (e.which == 13) {
                jumpToColor(this, true);
            }
        });
    }
    //end color options clicks
    
    colorOptionsClicks();
    
    //init product color scroller after jumpToColor
    function initProductColorScroller(){ 
         $('.prodImgSelected').click(function () { SaveProdColor(this); });
                
         $('.selectedImgDesc').click(function () { 
             var triggerImg = $(this).siblings('a').children('.prodImgSelected');
             if(recolorAvailable == 'False'){
                 triggerImg = $(this).parent('.prodImgSelected');
             }
             SaveProdColor(triggerImg); 
         });
                
         $('.selectedImgDesc').keypress(function (e) { 
             if(e.which == 13){
                 $(this).click();
             }
         });
         
         $('.imgBox').click(function () {
             var triggerImg = $(this).children('a').children('.prodImgSelected');
             SaveProdColor(triggerImg);
         });
         
         $('.imgBox a').attr('tabindex', '-1');
         $('.imgBox a').click(function(e) {
             e.preventDefault();
         });
    }
    //end init product color scroller
    
    initProductColorScroller();
    
    //init product color scroller slick
    function productColorScrollerSlick() {
        $("#productColorScroller").slick({
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 5,
            lazyLoad:"ondemand"
        });    
        
        $("#productColorScroller img").lazyload({
            threshold: 0,
            effect: "fadeIn",
            data_attribute: "lazy",
            failure_limit: 60
         });
    }
    //end product color scroller slick

    //save imprint color
    function SaveImprintColor(triggerElement) {
        ResetImprintCharges();
        $('.errorMsg').remove();
        var selectedColor = $(triggerElement).css('background-color');
        var colorTitle = $(triggerElement).attr('title');
        var imprintLocID = $(triggerElement).siblings('.imprintLocationID').val();
        var imprintColorID = $(triggerElement).siblings('.imprintColorID').val();
        var productImprintLocationID = $(triggerElement).siblings('.productImprintLocationID').val();
        var child;
        var oneColor = true;
	 
        $('.' + imprintLocID).children('.colorList').each(function () {
            var rgbColor = $(this).children('.PD_ImprintColorChoiceBox').css('backgroundColor');
            if (rgbColor == "rgba(0, 0, 0, 0)" || rgbColor == "transparent") {
                child = $(this).children('.PD_ImprintColorChoiceBox').children('img');
                $(this).children('.PD_ImprintColorChoiceBox').html('');

                $(this).children('.imprintLocationID').val(imprintLocID);
                $(this).children('.imprintColorID').val(imprintColorID);
                $(this).children('.productImprintLocationID').val(productImprintLocationID);

                $(this).children('.PD_ImprintColorChoiceBox').html(child);
                $(this).children('.PD_ImprintColorChoiceBox').css("background-color", selectedColor);
                $(this).children('.PD_ImprintColorChoiceBox').children('img').prop({'title': colorTitle, 'alt': colorTitle});
                $(this).find('a.imprintClearColor').focus();
                oneColor = false;
                return oneColor;
            }
        });

        if (oneColor) {
            child = $('.' + imprintLocID).children('.colorList').first().children('.PD_ImprintColorChoiceBox').children('img');
            $('.' + imprintLocID).children('.colorList').first().children('.PD_ImprintColorChoiceBox').html('');
            $('.' + imprintLocID).children('.colorList').first().children('.PD_ImprintColorChoiceBox').first().html(child);
            $('.' + imprintLocID).children('.colorList').first().children('.PD_ImprintColorChoiceBox').css("background-color", selectedColor);
	     $('.' + imprintLocID).children('.colorList').first().children('.PD_ImprintColorChoiceBox').children('img').prop({'title': colorTitle, 'alt': colorTitle});
	     $('.' + imprintLocID).children('.colorList').first().find('a.imprintClearColor').focus();
	     
            $('.' + imprintLocID).children('.colorList').first().children('.imprintLocationID').val(imprintLocID);
            $('.' + imprintLocID).children('.colorList').first().children('.imprintColorID').val(imprintColorID);
            $('.' + imprintLocID).children('.colorList').first().children('.productImprintLocationID').val(productImprintLocationID);
        }

        ValidateCustomizeSections();
    }
    //end save imprint color

    //close color picker
    function CloseColorPicker(triggerElement) {
        $(triggerElement).parent('.imprint-colors-content').toggle('slow');
    }//end color picker

    //QA
    function initQAPages() {
        $('.qapageselect').each(function () {
            $('#' + this.id).click(function () {
                //fitRatingFilter
                var vals = this.id.split('_');
                var page = vals[1];
                loadingPage();
                $.ajax({
                    url: "/productmvc/qandapage/" + prodID + "/" + page,
                    type: "GET",
                    contentType: 'application/json',
                    dataType: 'html',
                    success: function (result) {
                        $('#QandAPage').html('');
                        $('#QandAPage').html(result);
                        hideLoading();
                        initQAPages();
                    },
                    error: function(){
                    	hideLoading();
                    }
                });
            });
            $('#' + this.id).keypress(function (e) {
            		if(e.which == 13){
            			$(this).click();
            		}
            });
        });
    }

    function ResetImprintCharges() {
        //$('.extrasResult').fadeOut('slow').html('');
        $('.extrasResult').html('').hide();
    }

    //GRABS ALL SELECTED IMPRINT LOCATION AND COLORS AND SETS THEM IN PRODUCT SUMMARY AFTER ADD TO CART
    function SetSummaryImprintColors() {
        var newContent = "";
        if (listSelectedImprintLocationName.length > 0 && listSelectedColorsRGB.length > 0 && totalImprintColors > 0) {
            for (var i = 0; i < listSelectedImprintLocationName.length; i++) {
                newContent += "<div class='clear tinySpace'></div><h5 class='textsemibold'>Imprint Location</h5>" +
    					"<p>" + listSelectedImprintLocationName[i] +
    					"</p><div class='clear tinySpace'></div><h5 class='textsemibold'>Imprint " + localizedJS.ColorCap + "(s)</h5>";
                for (var j = 0; j < listSelectedColorsRGB[i].length; j++) {
                    newContent +=
                    "<div class='imprintColorSummary floatLeft marginTop5 marginBtm20 marginRight5 borderDkGray' style='background-color: " + listSelectedColorsRGB[i][j] +
                    "'><img alt='Selected " + localizedJS.ColorCap + "' title='Selected " + localizedJS.ColorCap + "' class='PD_ImprintColorChoiceSpacer selectedColorChip' src='data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='></div>";
                }
            }
        } else if (totalImprintColors == 0) {
            for (var i = 0; i < listSelectedImprintLocationName.length; i++) {
                newContent += "<div class='clear tinySpace'></div><h5 class='c-sm-quarter-2 c-xs-full floatLeft textsemibold'>Imprint Location</h5>" +
    					"<div class='c-sm-quarter-2 c-xs-full floatLeft'><p class='floatRightOnMedium'>" + listSelectedImprintLocationName[i] +
    					"</p></div><div class='clear'></div>";
            }
        }

        $('.imprint-location-summary').prepend(newContent);
    }//END IMPRINT LOCATION AND COLORS

    //VALIDATE ALL ITEM CUSTOMIZATION STEPS AND ACTIVATE ADD TO CART BUTTON
    function ValidateCustomizeSections() {
        GetSelectedImprintLocations();
        GetSelectedImprintColors();

        if (listImprintLocationIDs.length > 0) {
            if (listSelectedColors.length == 0 && totalImprintColors > 0) {
                if ($('.CheckMarkImprintLoc > span').hasClass('textGreen')) {
                    $('.CheckMarkImprintLoc > span').removeClass('textGreen');
                    $('.btnAddToCart').removeClass('bkgdRed').addClass('disabledBtn');
                    $('.btnAddToCart').removeClass('whiteLink');
                }
            } else {
                $('.CheckMarkImprintLoc').children('span').addClass('textGreen');
                $('.btnAddToCart').removeClass('disabledBtn bkgdDkGray').addClass('bkgdRed whiteLink');
                //$('.btnAddToCart').addClass('whiteLink');
            }
        } else {
            if ($('.CheckMarkImprintLoc > span').hasClass('textGreen')) {
                $('.CheckMarkImprintLoc > span').removeClass('textGreen');
                $('.btnAddToCart').removeClass('bkgdRed whiteLink').addClass('disabledBtn bkgdDkGray');
                //$('.btnAddToCart').removeClass('whiteLink');
            }
        }
    }//END VALIDATION

    function GetSelectedImprintLocations() {
        listImprintLocationIDs = [];
        listProductImprintLocationIDs = [];
        if (totalImprintColors == 0) {
            listSelectedImprintLocationName = [];
        }

        $('.chkbxImprintLocation').each(function () {
            if ($(this).prop('checked')) {
                var x = [];
                var inputImpLocID = $(this).siblings('.imprintLocationID').val();
                var imprintLocationName = $(this).siblings('.imprintLocationName').val();
                var impl = null;
                var prodimploc = null;
                var imprintColorsFound = $(this).parent().siblings('.imprintColorsFound').val();

                if (totalImprintColors == 0) {
                    listImprintLocationIDs.push(inputImpLocID);
                    listSelectedImprintLocationName.push(imprintLocationName);
                }
                else {
                    if (imprintColorsFound == undefined || imprintColorsFound == '') {
                        $('.' + inputImpLocID).children('.colorList').each(function () {
                            var imprintLocationID = $(this).children('.imprintLocationID').val();
                            var imprintColorID = $(this).children('.imprintColorID').val();
                            var productImprintLocationID = $(this).children('.productImprintLocationID').val();
                            if (imprintLocationID != undefined && imprintColorID != undefined && productImprintLocationID != undefined) {
                                if (imprintLocationID != "" && imprintColorID != "" && productImprintLocationID != "") {
                                    impl = imprintLocationID;
                                    prodimploc = productImprintLocationID;
                                }
                            }
                        });
                    } else {
                        impl = inputImpLocID;
                    }

                    if (impl != null) {
                        listImprintLocationIDs.push(impl);
                    }
                    if (prodimploc != null) {
                        listProductImprintLocationIDs.push(prodimploc);
                    }
                }
            }
        });
    }

    //GET ALL SELECTED SIZES AND THEIR QUANTITY FOR APPAREL PRODUCT
    function GetSelectedSizes() { 
        var sizeHash = "";
        if ($('.isApparelItem').val() == "True") {
            $('.sizeOptions').each(function () {
            	var sizeQty = $(this).find('.txtApparelQty ').val();
            	if(sizeQty != '' && sizeQty != undefined){
            		var saPID = $(this).find('.sizeAttrProdID').val();
            		var saID = $(this).find('.sizeAttrID').val();
            		var qty =  $(this).find('.txtApparelQty ').val();
            		sizeHash +=  saPID + '-' + saID + '-' + qty + '|';
            	}                           
            });
        }
        return sizeHash;
    }

    //get optional extras
     function LoadOptionalExtras() {
        var qty = $('#txtQty').val();

        if ($('.isApparelItem').val() == "True") {
            qty = $('#txtQty').html();
        }

        $.ajax({
            type: "POST",
            url: "/product/ExtrasOptional.aspx",
            data: { 'ProductID': prodID, 'Quantity': qty },
            dataType: "html",
            timeout: 15000,
            success: function (data) {
                optionalExtras = data;
                var parsedData = $.parseJSON(data);

                if (parsedData != null && parsedData.extras.length > 0) {
                    var ExtrasText = "";

                    for (var i = 0; i < parsedData.extras.length; i++) {

                        // determine if the checkbox should be checked
                        var checkit = "";
                        if (editID > 0) {
                            if ($('.SelectedOptionalExtras').val().indexOf('*' + parsedData.extras[i].id + ',') != -1) {
                                checkit = " checked = 'checked'";
                                UpdateOptionalExtraPrice(); // set price in "Current Selection" section
                            }
                        }

                        var unitprice = parsedData.extras[i].unitprice;
                        var qty = $('.selectedQty').html();
                        var totalprice;
                        if (!isNaN(unitprice)) { totalprice = (unitprice * qty).toFixed(2); }
                        ExtrasText += "<div class='imprintLocCheck clear'>";
                        ExtrasText += "<input type='checkbox' value='" + parsedData.extras[i].id + "' id='opt" + parsedData.extras[i].id + "' name='opt" + parsedData.extras[i].id + "' onchange='AddSelectedExtra(this)'" + checkit + " />";
                        ExtrasText += "<label for='opt" + parsedData.extras[i].id + "'>" + parsedData.extras[i].displayname + "</label>";
                        if (!isNaN(totalprice)) { ExtrasText += " - <span>For an Additional " + currencySymbol + totalprice + " (" + FormatMoneyUS(parsedData.extras[i].unitprice) + " per piece)</span><br />"; }
                        ExtrasText += "<span class='textDarkestGray paddingLeft10 text14'>(" + parsedData.extras[i].displaydesc + ")</span>";
                        ExtrasText += "</div>";
                    }

                    $('#haloOptions').html(ExtrasText);
                    $('#PD_OptionalExtra').show();
                }
            },
            error: function () {
                $('#PD_OptionalExtra').hide();
            }
        });
    } 
    //end optional extras

    //add extra
    AddSelectedExtra = function (cb) {
	$('.GFeedPanel1').remove();
        var currentselection = $('#SelectedOptionalExtras'); // this holds all the selected extras in '*11, *33,'
        if (cb.checked) {
            if (currentselection.val().indexOf('*' + cb.value + ',') == -1) {
                newExtra = currentselection.val() + '*' + cb.value + ',';
                currentselection.val(newExtra);
                
            }
        } else {
            // remove from if is there
            if (currentselection.val().indexOf('*' + cb.value + ',') != -1) {
                currentselection.val(currentselection.val().replace('*' + cb.value + ',', ''));
                $('#selectedOptionalExtraResult').hide();
                return false;
            }
        }

        $('.optionalExtrasLoadingImg').show();
        $('#selectedOptionalExtraResult').hide();
        //$('#SelectedOptionalExtras').val(currentselection);
        UpdateOptionalExtraPrice(); // add to the total
        //ResetCalcExtras(); // update the other extras total
    };

    function UpdateOptionalExtraPrice() {
        var qty = parseInt($('#txtQty').val());
        $.ajax({
            type: "POST",
            url: "/product/ExtrasOptional.aspx",
            data: { 'ProductID': prodID, 'Quantity': qty },
            dataType: "html",
            beforeSend: function () {

            },
            complete: function () {
                $('.optionalExtrasLoadingImg').hide();
            },
            timeout: 15000,
            success: function (data) {

                var parsedData = $.parseJSON(data);
                if (parsedData != null && parsedData.extras.length > 0) {
                    var ExtrasText = "";
                    var totalprice = parseFloat($('#lblTotal').html().replace(currencySymbol, '').trim());
                    for (var i = 0; i < parsedData.extras.length; i++) {
                        var currentselection = $('#SelectedOptionalExtras').val();
                        if (currentselection.indexOf('*' + parsedData.extras[i].id + ',') != -1) { // check here if extraID is in .SelectedOptionalExtras
                            var qty = parseInt($('#txtQty').val());
                            var unitprice = parseFloat(parsedData.extras[i].unitprice);
                            var optionaltotal = qty * unitprice;
                            totalprice = totalprice + optionaltotal;

                            ExtrasText += "<div class='extraDetailsLine'>";
                            ExtrasText += "<div class='floatLeft extraDetailsDescCol textsemibold'>" + parsedData.extras[i].displayname + "</div>";
                            //ExtrasText += "<div class='floatRight extraDetailsNumCol marginLeft10'> " + currencySymbol + optionaltotal.toFixed(2) + "</div>";
                            ExtrasText += "<div class='floatRight extraDetailsNumCol marginLeft10'>" + $('#txtQty').val() + "  @  " + currencySymbol + unitprice.toFixed(2) + " each = " + currencySymbol + optionaltotal + "</div>";
                            ExtrasText += "<div class='clear'></div>";
                            ExtrasText += "</div>";
                        }
                    }

                    if (totalprice != parseFloat($('#lblTotal').html().replace(currencySymbol, '').trim())) {
                        // only need to show this if the total price is different from the quantity selected price
                        $('#grandTotal').html(totalprice);
                    }

                    $('#selectedOptionalExtraResult').html(ExtrasText);
                    $('#selectedOptionalSummary').html(ExtrasText);
                    $('#selectedOptionalExtraResult').show();

                }
            },
            error: function () {
            }
        });
    }

    function ResetCalcExtras() {
        $('.extrasLoadingImg').hide();
        $('.extrasResult').slideUp('fast', function () {
            $('.calcExtrasBtn').fadeIn();
        });
        $('#selectedExtras').slideUp('fast');
    }
    //end add extra

    // render tooltips
    function RenderToolTips() {
        $('.jsToolTip').tooltip({
            content: function () {
                return this.getAttribute("title");
            }
        });
        $('.setupHelpTooltip').tooltip({
            content: function () {
                return this.getAttribute("title");
            }
        });
    }
    // end render tooltips

    //scroll to element
    function ScrollToElement(selector, time, verticalOffset) {
        time = typeof (time) != 'undefined' ? time : 1000;
        verticalOffset = typeof (verticalOffset) != 'undefined' ? verticalOffset : 0;
        element = $(selector);
        offset = element.offset();
        offsetTop = offset.top + verticalOffset;
        $('html, body').animate({
            scrollTop: offsetTop
        }, time);
    }
    //end scroll to element

    //calcualte extra upcharges
    function GetExtras(triggerElement) {
        var chkdImprintLoc = 0;
        $('.chkbxImprintLocation').each(function () {
            if ($(this).is(':checked')) {
                chkdImprintLoc++;
            }
        });

        if (chkdImprintLoc > 0) {
            var qty = 0;
		if ($('.isApparelItem').val() == 'False') {
            	qty = parseInt($("#txtQty").val());
        	} else { 
            	qty = parseInt($("#txtQty").html());
        	} 

            GetSelectedImprintColors();
            GetSelectedImprintLocations();

            if (listImprintLocationIDs.length == 0 || listProductImprintLocationIDs.length == 0 || listSelectedColors.length == 0) {
                $('.PD_Step_2').find('.errorMsg').remove();
                if (totalImprintColors > 0) {
                    $('.imprint-location').first().before('<p class="textDkRed errorMsg borderDkRed padding10 marginLeft20 paddingLeft15 textsemibold marginTop10" role="alert">Please select at least one imprint location and one imprint ' +  localizedJS.Color + '</p>');
                    ScrollToElement('.PD_Step_2');
                    return false;
                }
            }

            var arrImprintLocationIDs = listImprintLocationIDs;
            var arrProductImprintLocationIDs = listProductImprintLocationIDs;
            var arrImprintColorsIDs = listSelectedColors;
            var adhesiveAttributeID = $('#adhSideOptions').find('input:checked').siblings('input').val();
            var nibColorAttributeID = $('#inkColorOptions').find('input:checked').siblings('input').val();
            var baseTrimColor = selBaseTrim.val().split('/');
            if (adhesiveAttributeID == "") {
                adhesiveAttributeID = undefined;
            }
            var OrderSummary = {
                ProductID: prodID, Quantity: qty, ImprintColors: arrImprintColorsIDs, ImprintLocations: arrImprintLocationIDs, BaseColorID: baseTrimColor[0], TrimColorID: baseTrimColor[1],
                EditID: editID, ProductImprintLocations: arrProductImprintLocationIDs, NibColorAttributeID: nibColorAttributeID, AdhesiveAttributeID: adhesiveAttributeID
            };

            $.ajax({
                type: "POST",
                url: "/productmvc/calculateextras",
                data: JSON.stringify(OrderSummary),
                dataType: "html",
                contentType: "application/json",
                beforeSend: function (req) {
                    //$('.calcExtrasBtn').fadeOut('fast');
                    $(triggerElement).siblings('.extrasLoadingImg').fadeIn('fast');
                    ResetImprintCharges();
                },
                complete: function (req) {
                    $(triggerElement).siblings('.extrasLoadingImg').fadeOut('fast');
                    //ExtrasComplete();
                },
                //done: function(){ ExtrasComplete();  },
                success: function (data) {
                    if (data.indexOf('extrasError') < 0) {
                        $('#setupChrgSummary').html(data);
                    } else {
                        $('#setupChrgSummary').html('<p class="textsemibold" role="alert">Add To Cart To View Any Imprint Charges</p>');
                    }

                    $(triggerElement).siblings('.extrasResult').html(data + "<div class='clear'></div>");
                    RenderToolTips();
                    $(triggerElement).siblings('.extrasLoadingImg').fadeOut('fast', function () {
                        $(triggerElement).siblings('.extrasResult').slideDown('fast');
                    });

                    var ExtraTemplate = $('#selectedExtrasBox').children('.selectedExtraLine').eq(0);
                    var ExtrasTotal = 0.00;
                    var Extras = $(document.createElement("div")).attr('id', 'ExtraDummy');
                    $('#setupChrgSummary').children('.extraDetailsLine').each(function () {
                        var NewExtra = ExtraTemplate.clone(false);
                        var LineTotal;
                        var LinePrice;
                        var LineQty;
                        $(this).find('span.LineTotal').each(function (e) {
                            LineTotal = $(this).html();
                        });

                        if (LineTotal != undefined && LineTotal != "") {
                            ExtrasTotal += parseFloat(LineTotal.replace(LineTotal.substring(0, 1), ''));
                        }
                        NewExtra.children('.selectionExtraDesc').html($(this).children('div.extraDetailsDescCol').html());
                        if (LinePrice == '' || LineQty == '') {
                            NewExtra.children('.selectionExtraQtyPrice').html('');
                        } else {
                            NewExtra.children('.selectionExtraQtyPrice').html(LineQty + ' @ ' + LinePrice);
                        }

                        NewExtra.appendTo(Extras);
                    });

                    currencySymbol = currencySymbol.replace(/\s+/g, '');
                    var totalDisplayed = $('#lblTotal').html();
                    totalDisplayed = totalDisplayed.replace(/\s+/g, '');
                    var total = (ExtrasTotal + parseFloat(totalDisplayed.replace(totalDisplayed.substring(0, 1), ''))).toFixed(2).toString();
                    $('#currencySymbol').html(currencySymbol);
                    $('#grandTotal').html(total);
                    $('#GFeedBasePrice').html(currencySymbol + ExtrasTotal);
                    if (qryStr > 0) { 
				if(ukTaxRate != '0'){
					//UK locale, add VAT				
            			$('#VatTax').html(currencySymbol + localizedJS.VatTax(ExtrasTotal, totalDisplayed.replace(currencySymbol, ''), ukTaxRate));
            			$('#GFeedFinalPrice').html(currencySymbol + localizedJS.TotalWithVat(ExtrasTotal, totalDisplayed.replace(currencySymbol, ''), ukTaxRate));
            		} else{
            			//Not UK
            			$('#GFeedFinalPrice').html(currencySymbol + total);
            		}
        		   }
                },
                error: function () {
                    $(triggerElement).siblings('.extrasLoadingImg').fadeOut('fast');
                    $(triggerElement).siblings('.extrasResult').html('<div role="alert">Sorry, an error occurred. Please <a href="#" onclick="return GetExtras();">click here</a> to try again. You can also view the imprint charges in your cart by click the Add to Cart button below.</div>');
                }
            });
        }
        return false;
    }
    //end extra charges

    var cartUrl = '';
    //add to cart
    function AddToCart() {
        //get selected imprint locations
        GetSelectedImprintLocations();
        //get selected imprint colors
        GetSelectedImprintColors();
        $('.PD_Step_2').find('.errorMsg').remove();

        if (listImprintLocationIDs.length == 0) {
            $('.imprint-location').first().before('<p class="textDkRed errorMsg padding10 borderDkRed margin20 textsemibold" role="alert">Please select at least one imprint location and one imprint ' + localizedJS.Color + '</p>');
            ScrollToElement('.PD_Step_2');
           $('.imprint-location').find('input').first().focus();
            return false;
        }

        if (listSelectedColors.length == 0 && totalImprintColors > 0) {
            //$('.PD_Step_2').find('.errorMsg').remove();
            $('.imprint-location').first().before('<p class="textDkRed errorMsg padding10 borderDkRed margin20 textsemibold" role="alert">Please select at least one imprint ' + localizedJS.Color + '</p>');
            ScrollToElement('.PD_Step_2');
            $('.imprint-location').find('input').first().focus();
            return false;
        }

        //get extra charges and update totals
        GetExtras();

        $('.extrasResult').hide();
        var adhesiveAttributeID = $('#adhSideOptions').find('input:checked').siblings('input').val();
        var nibColorAttributeID = $('#inkColorOptions').find('input:checked').siblings('input').val();
        var selectedOptionalExtras = $('#SelectedOptionalExtras').val();
        var selectedSizes = GetSelectedSizes();
        var qty = $('#txtQty').html();
        if (qty == undefined) {
            qty = $('#txtQty').val();
        }
        if (adhesiveAttributeID == "" || adhesiveAttributeID == undefined) {
            adhesiveAttributeID = $('#adhesiveOptions').find('input:checked').siblings('input').val();
        }
        var baseTrimColor = selBaseTrim.val().split('/');
        var arrImprintLocationIDs = listImprintLocationIDs;
        var arrProductImprintLocationIDs = listProductImprintLocationIDs;
        var arrImprintColorsIDs = listSelectedColors;
        var qty = 0;
        var priceEach = $("#lblPrice").html();
        var lblTotal = $('#lblTotal').html();
        var colorSelected = $("#colorSelected").val();
        if ($('.isApparelItem').val() == 'False') {
            qty = $("#txtQty").val();
        } else {
            qty = $("#txtQty").html();
        }

	   $('#priceEachSummary').html(qty + '  @  ' + priceEach + '  each  = <span class="textsemibold">' +  lblTotal + '</span>');
        //$('#priceEachSummary').text(qty + '  @  ' + priceEach + '  ea  ');
        $('#qtySummary').html(qty);
        $('#colorSummary').html(colorSelected);

        //get selected imprint colors
        SetSummaryImprintColors();

        //get adhesive side selected
        $('.PD_adhSideOptions').remove();
        var adhesiveSide = $('#adhSideOptions').children('div').length;
        if (adhesiveSide > 0) {
            var adhesiveType = $('#adhSideOptions').find('label').val();
            var adhesiveSideSelected = $('#adhSideOptions').find('input:checked').val();
            $('#colorSummary').parent().after('<div class="clear tinySpace"></div><div class="PD_adhSideOptions c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Adhesive Side</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="adhesiveSideSummary">' + adhesiveSideSelected + '</p></div>');
        }

        //get adhesive type selected
        $('.PD_adhesiveOptions').remove();
        var adhesiveType = $('#adhesiveOptions').children('div').length;
        if (adhesiveType > 0) {
            var adhesiveTypeSelected = $('#adhesiveOptions').find('label').html();
            var adhesiveSideSelected = $('#adhesiveOptions').find('input:checked').val();
            $('#colorSummary').parent().after('<div class="clear tinySpace"></div><div class="PD_adhesiveOptions c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Adhesive Type</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="adhesiveTypeSummary">' + adhesiveTypeSelected + ' : ' + adhesiveSideSelected + '</p></div>');
        }

        //get nib type selected
        $('.PD_NibTypeSummary').remove();
        var nibType = $('#nibOptions').children('div').length;
        if (nibType > 0) {
            var nibTypeSelected = $('#nibOptions').find('input:checked').val();
            $('#colorSummary').parent().after('<div class="clear tinySpace"></div><div class="PD_NibTypeSummary c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Tip Size</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="nibTypeSummary">' + nibTypeSelected + '</p></div>');
        }

        //get ink color selected
        $('.PD_inkColorSummary').remove();
        var inkColors = $('#inkColorOptions').children('div').length;
        if (inkColors > 0) {
            var inkColorSelected = $('#inkColorOptions').find('input:checked').val();
            $('#colorSummary').parent().after('<div class="clear tinySpace"></div><div class="PD_inkColorSummary c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Writing Ink ' + localizedJS.ColorCap + '</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="inkColorSummary">' + inkColorSelected + '</p></div>');
        }

        var OrderSummary = {
            ProductID: prodID, Quantity: qty, ImprintColors: arrImprintColorsIDs, ImprintLocations: arrImprintLocationIDs, SelectedSizes: selectedSizes, BaseColorID: baseTrimColor[0], TrimColorID: baseTrimColor[1],
            EditID: editID, ProductImprintLocations: arrProductImprintLocationIDs, NibColorAttributeID: nibColorAttributeID, AdhesiveAttributeID: adhesiveAttributeID, SelectedOptionalExtras: selectedOptionalExtras
        };

        $.ajax({
            url: "/productmvc/addtocart",
            type: "POST",
            datatype: 'json',
            contentType: "application/json",
            data: JSON.stringify(OrderSummary),
            beforeSend: function () {
                $('.cartLoadingImg').show();
                $('.cartError').html('');
            },
            success: function (result) {
                //$('.cartLoadingImg').toggle('slow');
                if (result.success == "true") {
                    OmniLogCartAdd(result.newCart == undefined ? true : result.newCart);
                    //Item Summary will be disabled for now.
                    /*$('.PD_Step_2').fadeOut('slow', function () {
                        $('.PD_Summary').fadeIn('100', function () {
                            $('.PD_Summary').removeClass('hide');
                            ScrollToElement('.PD_Summary', 500);
                        });
                    }); */
                    //This might be added back in the future. JWW 10/24
                    cartUrl = result.redirectUrl;
                    window.location.href = result.redirectUrl;                  
                } else {
                    $('.cartError').html('<div aria-live="polite">There was an error adding item to Cart. Please try again!</div>');
                }
            },
            error: function () {
                $('.cartError').html('<div aria-live="polite">There was an error adding item to Cart. Please try again!</div>');
            },
            done: function () {
                $('.cartLoadingImg').hide();                 
            }
        });
    }
    //end add to cart

	//paging loading gif and overlay
	function loadingPage(){
		$('.loadingPage').show();
		$('.loadingPage').removeClass('hide');
	}
	
	function hideLoading(){
		$('.loadingPage').hide();
		$('.loadingPage').addClass('hide');
	}
	
	//customerimages
	function initCustomerImagesPages() {
            $('.imagespageselect').each(function () {
                $('#' + this.id).click(function () {
                    var vals = this.id.split('_');
                    var page = vals[1];
                    loadingPage();
                    $.ajax({
                        url: "/productmvc/customerimages/" + prodID + "/" + page,
                        type: "GET",
                        contentType: 'application/json',
                        dataType: 'html',
                        success: function (result) {
                            $('#customerImagesTSTab').html('');
                            $('#customerImagesTSTab').html(result);
                            hideLoading();
                            initCustomerImagesPages();
                        },
                        error: function () {
                            hideLoading();
                            //add error msg?
                        }
                    });
                });
                $('#' + this.id).keypress(function (e) {
                    if (e.which == 13) {
                        $(this).click();
                    }
                });
            });
        }
	 //end customerimages

    //review/successstories functions
    function initSuccessPages() {
        $('.storiespageselect').each(function () {
            $('#' + this.id).click(function () {
                var vals = this.id.split('_');
                var page = vals[1];
                loadingPage();
                $.ajax({
                    url: "/productmvc/successstories/" + prodID + "/" + page,
                    type: "GET",
                    contentType: 'application/json',
                    dataType: 'html',
                    success: function (result) {
                        $('#successStoriesTSTab').html('');
                        $('#successStoriesTSTab').html(result);
                        hideLoading();
                        initSuccessPages();
                    },
                    error: function(){
                     	hideLoading();
                     	//add error msg?
                    }
                });
            });
            $('#' + this.id).keypress(function (e) {
	            	if(e.which == 13){ 
	            		$(this).click();
	            	}
            });
        });
    }

    function initReviewPages() {
        $('.reviewspageselect').each(function () {
            $('#' + this.id).click(function () {
                var vals = this.id.split('_');
                var page = vals[1];
                loadingPage();
                $.ajax({
                    url: "/productmvc/reviews/" + prodID + "/" + page + "/" + document.getElementById('reviewsPerPage').value + "/" + document.getElementById('reviewsOrderBy').value + "/" + document.getElementById('reviewsFilter').value,
                    type: "GET",
                    contentType: 'application/json',
                    complete: function(){
                    	$('.positiveReview').on('click');
			      $('.negativeReview').on('click');
                    },
                    dataType: 'html',
                    success: function (result) {
                        $('#reviewsTSTab').html('');
                        $('#reviewsTSTab').html(result);
                        hideLoading();
                        initReviewPages();
                        initReviewFilters();
                    },
                    error: function(){
                       hideLoading();
                    }
                });
            });
            $('#' + this.id).keypress(function (e) {
            		if(e.which == 13){
            			$(this).click();
            		}
            });
        });
    }

    function initReviewFilters() {
        $('.reviewOptions').change(function () {
        	 loadingPage();
            $.ajax({
                url: "/productmvc/reviews/" + prodID + "/1/" + document.getElementById('reviewsPerPage').value + "/" + document.getElementById('reviewsOrderBy').value + "/" + document.getElementById('reviewsFilter').value,
                type: "GET",
                contentType: 'application/json',
                dataType: 'html',
                success: function (result) {
                    $('#reviewsTSTab').html('');
                    $('#reviewsTSTab').html(result);
                    hideLoading();
                    initReviewPages();
                    initReviewFilters();
                },
                error: function(){
                   hideLoading();
                }
            });
        });
        $('#readAllReviews').click(function () {
        	 showReviewsLoading();
            $.ajax({
                url: "/productmvc/reviews/" + prodID + "/1",
                type: "GET",
                contentType: 'application/json',
                dataType: 'html',
                success: function (result) {
                    $('#reviewsTSTab').html('');
                    $('#reviewsTSTab').html(result);
                    hideReviewsLoading();
                    initReviewPages();
                    initReviewFilters();
                },
                error: function(){
                    	hideReviewsLoading();
                }
            });
        });
        $('#readAllReviews').keypress(function (e) {
        	if(e.which == 13){
        		$(this).click();
        	}
        });
        $('.reviewFilter').each(function () {
            $('#' + this.id).click(function () {
                var vals = this.id.split('_');
                var filter = '';
                if (vals.length > 1) {
                    filter = vals[1];
                }
                showReviewsLoading();
                $.ajax({
                    url: "/productmvc/reviews/" + prodID + "/1/" + document.getElementById('reviewsPerPage').value + "/" + document.getElementById('reviewsOrderBy').value + "/" + filter,
                    type: "GET",
                    contentType: 'application/json',
                    dataType: 'html',
                    success: function (result) {
                        $('#reviewsTSTab').html('');
                        $('#reviewsTSTab').html(result);
                        hideReviewsLoading();
                        initReviewPages();
                        initReviewFilters();
                        $('#reviewsOrderBy').focus();
                    },
                    error: function(){
                    	hideReviewsLoading();
                    }
                });
                return false;
            });
        });
    }
     function showReviewsLoading(){
		var container = $('#ReviewsContainer');
		$('#ReviewsLoadingImg').css({'height':container.height()});
		$('#ReviewsLoadingImg').show();
		$('#ReviewsLoadingImg').removeClass('hide');
    }
    
    function hideReviewsLoading(){
    		$('#ReviewsLoadingImg').hide();
		$('#ReviewsLoadingImg').addClass('hide');
    }
    //end review/successstories functions

    //more fitRating
    function initFitRatingPages() {
        $('.fitratingpageselect').each(function () {
            $('#' + this.id).click(function () {
                //fitRatingFilter
                var vals = this.id.split('_');
                var page = vals[1];
                loadingPage();
                $.ajax({
                    url: "/productmvc/customerfitrating/" + prodID + "/" + page + "/" + document.getElementById('fitRatingFilter').value,
                    type: "GET",
                    contentType: 'application/json',
                    dataType: 'html',
                    success: function (result) {
                        $('#customerfitcomments').html('');
                        $('#customerfitcomments').html(result);
                        hideLoading();
                        initFitRatingPages();
                    },
                    error: function (){
                    	hideLoading();
                    	//add error msg?
                    }
                });
            });
            $('#' + this.id).keypress(function (e) {
            		if(e.which == 13){
            			$(this).click();	
            		}
            });
        });
    }
    //end more fitRating


    //apparel glide
    function CalcPrice() {
        var TotalQty = 0;
        $('.txtApparelQty').each(function () {
            if ($(this).val() != '') {
                if (IsNumeric($(this).val())) {
                    TotalQty += parseInt($(this).val());
                }
            }
        });
        $('#txtQty').html(TotalQty);
        if (TotalQty >= lowestQty) {
            $('.qtyErrorMsg').remove();
             $('#txtQty').removeAttr('style');
            $('.CheckMarkQuantity').children('span').addClass('textGreen');
            if (selBaseTrim.val() != "") {
                $('.step1').removeClass('disabledBtn').addClass('bkgdBlue whiteLink');
            }
            var BreakNumBelow = -1;
            var BreakNumAbove = -1;
            for (var i = 0; i < arrBreak.length; i++) {
                if ((i + 1 >= arrBreak.length || arrBreak[i + 1] < 1) && TotalQty >= arrBreak[i] && arrBreak[i] > 0) {
                    BreakNumBelow = i;
                    BreakNumAbove = i;
                } else {
                    if (TotalQty >= arrBreak[i] && TotalQty < arrBreak[i + 1]) {
                        BreakNumBelow = i;
                        BreakNumAbove = i + 1;
                    }
                }
            }

            var newPrice = EstimatePrice(BreakNumBelow, TotalQty, 0);
            $('#lblPrice').html(currencySymbol + newPrice.toFixed(2).toString());
            $('#lblTotal').html(currencySymbol + (newPrice * TotalQty).toFixed(2).toString());
        } else {
            $('.CheckMarkQuantity').children('span').removeClass('textGreen');
            $('.step1').addClass('disabledBtn').removeClass('bkgdBlue whiteLink');
            $('#lblPrice').html('');
            $('#lblTotal').html('');
        }
    }

    function UnlockMoreColors(divNeedMoreColors, MaxImprintColors) {
        /// <summary>Called after clicking the more colors button, this displays the boxes after the first for additional color entries</summary>
        /// <param name="divNeedMoreColors">Div containing the more colors button</param>
        /// <param name="MaxImprintColors">Maximum number of imprint colors</param>
        //var MaxImprintColors = parseInt($('.imprintColorsCount').html());
        var colorsDisplayed = $(divNeedMoreColors).parent().siblings('.colorList').length;
        var colorsToAdd = MaxImprintColors - colorsDisplayed;
        $('#GFeedData').hide();
        $('.imprintButtonExtras').removeClass('hide');
        var newContent = "";
        for (var i = colorsDisplayed + 1; i <= MaxImprintColors; i++) {
            $(divNeedMoreColors).parent().siblings('.colorList').last().after(
            '<div class="colorList marginTop5"><div class="floatLeft paddingRight10">' + localizedJS.ColorCap + " " + i + '</div><span class="PD_ImprintColorChoiceBox selectedColor bkgdTransparent">' +
            '<img alt="Please select a ' + localizedJS.Color + ' from the ' + localizedJS.Color + ' picker" title="Please select a ' + localizedJS.Color + ' from the ' + localizedJS.Color + ' picker" class="PD_ImprintColorChoiceSpacer selectedColorChip" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="></span>' +
            '<input class="imprintLocationID" type="hidden" value="" /><input class="imprintColorID" type="hidden" value="" /><input class="productImprintLocationID" type="hidden" value="" />' +
            '<a class="imprintClearColor icon icon-trash darkLink text15 noLine marginLeft10 pointer" tabindex="0" role="button" title="Clear ' + localizedJS.Color + " " + i + '"></a></div>');
        }
        $(divNeedMoreColors).parent().hide();
        $('.PD_ImprintColorChip').first().find('.spnColorChip').focus();
    }

    //end apparel glide
    function getOrderTotal() {
        var priceEach = $("#lblPrice").html();
        var shipCost = 0;
        var setupCharge = 0;
        var quantity = $("#txtQty").val();

        return (priceEach * quantity) + setupCharge + shipCost;
    }//glide

    function onSlideEnd(sender, e) {
        UpdatePrice(sender.get_element().value);
    }

    function SetQuantity() {
        if (checkQty() && StoreColor()) {
            resetCalcExtras();
            $('.selectedQty').html($('#' + quantityTextbox).val());
            $('#SelectedQtyPrice').html($("#" + priceLabel).html().replace(currencySymbol, ''));
            $('#SelectedQtyTotal').html($("#" + totalLabel).html().replace(currencySymbol, ''));
            $('.PD_SelectionPanel').slideDown();
            $('.PD_SelectionBox').removeClass('hide').fadeIn();
            $('.PD_QuantityChoicePanel').fadeOut('normal', function () {
                $('.PD_ImprintChoicePanel').fadeIn();
            });
            LoadOptionalExtras();
        }
    }
    
    function updateGlideAria(){
    	 $(".jslider-pointer").attr("aria-valuenow", $('#txtQty').val().toString());	
    }

    function SetupGlide() {
        if (Glide4imprint) {
            glide = new Glide4imprint();
            glide.Init(arrBreak, arrPrice, steppingQty); 
            if ($.slider) {
                $("#GlideSlider").sliderglide({
                    from: glide.MinPoint(),
                    to: glide.MaxPoint(),
                    step: 1,
                    smooth: true,
                    scale: [glide.MinBreakQty(), glide.MaxBreakQty()],
                    limits: false,
                    dimension: '', // Needed for the hint bubble above slider
                    valueOffset: 18, // Custom added property, offsets the value bubble to the right (value is in px)
                    calculate: function (value) {
                        UpdatePrice(value.toString());
                        updateGlideAria();
                        //return quantityTextbox;
                        return $('#txtQty').val(); // Need to return the quantity for the hint bubble to display it
                    }
                });

                // The end values on the slider ui need to be updated manually
                var endpointLbls = $('div.jslider-scale span ins');
                
                endpointLbls.eq(0).html(glide.MinBreakQty());
                endpointLbls.eq(1).html(glide.MaxBreakQty());
		   
		   if ($('.isApparelItem').val() == "False") {
			    $(".jslider-pointer").attr({
			   	"tabindex": "0",
			   	"role": "slider",
			   	"aria-valuemin": glide.MinBreakQty().toString(),
			   	"aria-valuemax": glide.MaxBreakQty().toString(),
			   	"aria-valuenow": $('#txtQty').val().toString()
			   });
		   }
                // If editing update the slider with the appropriate qty
                if (editQty > 0) {
                   if ($('.isApparelItem').val() == "False") {
                        TextUpdateSliderFinish(editQty);
                    } else {
                        CalcPrice();
                    }
                }
            }
        }
    }

    function SetSlider(qty) {
        var prevValue = $("#GlideSlider").sliderglide("value");
        $("#GlideSlider").sliderglide("value", glide.SetSlideQty(qty));
    }

    function TextUpdateSlider(qty) {
        if (txtTimer != null) {
            clearTimeout(txtTimer);
        }
        txtTimer = setTimeout("TextUpdateSliderFinish('" + qty + "')", 500);
        //txtTimer = setTimeout(TextUpdateSliderFinish(qty), 500);
    }

    function CheckForSingleQtyBreak() {
        // The glide slider will be disabled if there is only one break, so need to fill the price each in with the one price
        if (arrBreak[2] <= 0) {
            var price = arrPrice[1];
            var qty = arrBreak[1];
            $('#txtQty').val(qty);
            $('#lblPrice').html(currencySymbol + price.toFixed(2).toString());
            $('#lblTotal').html(currencySymbol + (price * qty).toFixed(2).toString());
            $('.layout-slider').addClass('hide');
        }
    }

    function UpdatePrice(qty) {
        var firstDigit = glide.GetBreakSegment(qty);
        var quantity = glide.GetSlideQty(firstDigit, qty);
        if (glide.MinBreakQty() <= quantity) {
            if (firstDigit != null) {
                var newPrice = glide.GetPriceEstimate(firstDigit, quantity, qty);
                var startPrice = arrPrice[1]; // pricing always starts at index 1
                $('#lblPrice').html(currencySymbol + newPrice.toFixed(2).toString());
                $('#lblTotal').html(currencySymbol + (newPrice * quantity).toFixed(2).toString());
                $('#txtQty').val(quantity);
		     $('#txtQty').removeAttr('style');
                // Not used on intro page
                if (newPrice.toFixed(2) >= startPrice.toFixed(2)) {
                    if ($('div#YouSaveBox').css('visibility') == 'visible') { $('div#YouSaveBox').css('visibility', 'hidden'); }
                } else {
                    if ($('div#YouSaveBox').css('visibility') == 'hidden') { $('div#YouSaveBox').css('visibility', 'visible'); }
                    $('div#divYouSave').html(currencySymbol + ((startPrice * quantity) - (newPrice * quantity)).toFixed(2).toString());
                }
            }
        }
    }

    TextUpdateSliderFinish = function (qty) {
    	  $('.qtyErrorMsg').remove();
        if (glide.IsNumeric(qty)) {
        	$('.step1').removeClass('disabledBtn').addClass('bkgdBlue whiteLink');	
        	$('#txtQty').removeAttr('style').removeAttr('aria-invalid'); 
            qty = parseInt(qty);

            var SlideQty = qty;
            if (lowestQty > qty) { qty = lowestQty; } //enforce min quantity
            if (lowestQty <= qty) {
                for (var i = glide.BreakArray().length - 1; i > 0; i--) {
                    if (glide.BreakArray()[i] > 0) {
                        // If the qty is greater than the end of the slider, need to set the value to slide to to the last break.
                        if (qty > glide.BreakArray()[i]) {
                            SlideQty = glide.BreakArray()[i];
                            qty = glide.EnforceSteppingQty(qty, steppingQty);
                        }
                        break;
                    }
                }

                // Only update the slider if there are multiple qty breaks
                if (arrBreak[2] > 0) {
                    SetSlider(SlideQty);
                }

                // The slider doesn't deal in qtys, just percentages, so sometimes it will adjust the qty when it does
                // its percentage calculation if the user typed a qty. This will reset it to the user entered value.
                var qtyTxtbox = $('#txtQty');
                if (qty > SlideQty) {
                    qtyTxtbox.val(qty);

                    var price = $('#lblPrice').html().trim().substring(1);    // Trims the currency symbol
                    $('#lblTotal').html(currencySymbol + (price * qty).toFixed(2).toString());
                    $('.jslider-value span').first().html(qty);
                } else {
                    if (parseInt(qtyTxtbox.val()) != qty) {
                        if (glide.EnforceSteppingQty(qty, steppingQty) == qty) {
                            qtyTxtbox.val(qty);
                            var price = $('#lblPrice').html().trim().substring(1);
                            $('#lblTotal').html(currencySymbol + (price * qty).toFixed(2).toString());
                            $('.jslider-value span').first().html(qty);
                        }
                    }
                }
                qtyTxtbox.select();
            }
        } else {
        	$('.pnlSelColors').after('<p class="textDkRed qtyErrorMsg borderDkRed padding10 textsemibold marginLeft20 paddingLeft15 marginTop10" role="alert">Please enter a valid quantity. Minimum quantity for this item is ' + lowestQty + '</p>');
        	$('.step1').removeClass('bkgdBlue whiteLink').addClass('disabledBtn');	
        	$('input#txtQty').css('background-color', '#ffd9d9').attr('aria-invalid', 'true').focus();
        	return false;
        }
        
    };

    function IsNumeric(strString) {
        var strValidChars = "0123456789";
        var strChar;
        var blnResult = true;


        for (i = 0; i < strString.length && blnResult == true; i++) {
            strChar = strString.charAt(i);
            if (strValidChars.indexOf(strChar) == -1) {
                blnResult = false;
            }
        }
        return blnResult;
    }

    function SelectQty(columnId) {
        /// <summary>Changes the quantity to the value of the price break that the user clicked on</summary>
        /// <param name="columnId">Column index in the price break table</param>
        if (arrBreak[columnId] > 0) {
            $('#txtQty').val(arrBreak[columnId]);
            SetSlider(arrBreak[columnId]);
        }
    }
    //end glide

    function showPos(event) {
        var Flyout;
        Flyout = document.getElementById('PD_360Flyout');
        Flyout.style.display = "block";
    }

    function ShowImprintColors(triggerDiv) {
        //$(triggerDiv).parent().parent().siblings(".imprint-colors-content").toggle("slow");
        if ($(triggerDiv).parent().siblings('.chkbxImprintLocation').prop('checked') == true) {
            $(triggerDiv).parent().siblings('.chkbxImprintLocation').prop('checked', false);
            $(triggerDiv).parent().siblings(".imprint-colors-content").fadeOut("slow");
        } else {
            $(triggerDiv).parent().siblings('.chkbxImprintLocation').prop('checked', true);
            $(triggerDiv).parent().siblings(".imprint-colors-content").fadeIn("slow");
        }
    }

    function ScrollToElement(selector, time, verticalOffset) {
        time = typeof (time) != 'undefined' ? time : 1000;
        verticalOffset = typeof (verticalOffset) != 'undefined' ? verticalOffset : 0;
        element = $(selector);
        offset = element.offset();
        offsetTop = offset.top + verticalOffset;
        $('html, body').animate({
            scrollTop: offsetTop
        }, time);
    }

    //Load adhesive options
    function LoadAdhesiveOptions() {
        var baseTrim = selBaseTrim.val();
        if (baseTrim != undefined && baseTrim != "") {
            $.ajax({
                type: "POST",
                url: "/ajax/details/adhesive.aspx",
                data: { 'ProductID': prodID, 'Color': baseTrim },
                dataType: "html",
                timeout: 15000,
                success: function (data) {
                    adhSidesOptions = data;
                    var parsedData = $.parseJSON(data);
                    if (parsedData != null && parsedData.adhesive.length > 0) {
                        adhSidesOptions = parsedData; // Set to the global object for use when the user is making selections

                        var AdhesiveOptions = new Array();
                        var AdhSideOptions = new Array();
                        var AdhesiveOptionIDs = new Array();
                        var AdhesiveSideIDs = new Array();

                        var EditAdhesiveValue = '';
                        var EditAdhSideValue = '';

                        for (var i = 0; i < parsedData.adhesive.length; i++) {
                            var optionFound = false;

                            // Look to see if the option has already been added to the adhesive option array
                            for (var j = 0; j < AdhesiveOptions.length; j++) {
                                if (!optionFound && AdhesiveOptions[j] == parsedData.adhesive[i].adh) {
                                    optionFound = true;
                                }
                            }

                            // if the adhesive option was not found, add the option to the array for display
                            if (!optionFound) {
                                AdhesiveOptions[AdhesiveOptions.length] = parsedData.adhesive[i].adh;
                                AdhesiveOptionIDs[AdhesiveOptionIDs.length] = parsedData.adhesive[i].id;
                            } else {
                                optionFound = false;    // Reset the variable for the color check
                            }

                            // Look to see if the option has already been added to the side option array
                            for (var j = 0; j < AdhSideOptions.length; j++) {
                                if (!optionFound && AdhSideOptions[j] == parsedData.adhesive[i].side) {
                                    optionFound = true;
                                }
                            }

                            // if the side option was not found, add the option to the array for display
                            if (!optionFound) {
                                AdhSideOptions[AdhSideOptions.length] = parsedData.adhesive[i].side;
                                AdhesiveSideIDs[AdhesiveSideIDs.length] = parsedData.adhesive[i].id;
                            }

                            if (editID > 0) {
                                if (parsedData.adhesive[i].id == adhesiveInput.val()) {
                                    EditAdhSideValue = parsedData.adhesive[i].side;
                                    EditAdhesiveValue = parsedData.adhesive[i].adh;
                                }
                            }
                        }

                        // All adhesive and side options have been located, now display them if there's more than 1
                        if (AdhesiveOptions.length > 1) {
                            AdhesiveOptions.sort();
                            $('#adhesiveOptions input').unbind('click', adhesiveOptionChanged); // Unbind the handler from any previous radio buttons
                            $('#adhesiveOptions').html(''); // Remove any previously displayed radio buttons
                            for (var i = 0; i < AdhesiveOptions.length; i++) {
                                var inputId = "adhesive" + i;
                                var radioBtn = '<div class="floatLeft marginLeft10 marginRight10"><input type="radio" id="' + inputId + '" name="adhesive" tabindex="0" value="' + AdhSideOptions[i] + '"';

                                // Set up the selected option, the first option by default if the item is not being edited
                                if ((editID > 0 && AdhesiveOptions[i] == EditAdhesiveValue) || (editID <= 0 && i == 0)) {
                                    radioBtn += ' checked';
                                }

                                radioBtn += ' />';

                                radioBtn += '<label for="' + inputId + '" name="' + AdhSideOptions[i] + '">' + AdhesiveOptions[i] + '</label><input type="hidden" value="' + AdhesiveOptionIDs[i] + '" /></div>';

                                $('#adhesiveOptions').append(radioBtn);
                            }
                            $('.PD_Adhesive').show();
                            $('#adhesiveOptions input').bind('click', adhesiveOptionChanged); // Bind the handler to the new radio buttons
                        } else {
                            $('.PD_Adhesive').hide();
                        }

                        if (AdhSideOptions.length > 1) {
                            AdhSideOptions.sort();
                            $('#adhSideOptions input').unbind('click', adhesiveOptionChanged); // Unbind the handler from any previous radio buttons
                            $('#adhSideOptions').html(''); // Remove any previously displayed options
                            for (var i = 0; i < AdhSideOptions.length; i++) {
                                var adhesiveSide = "adhesiveSide" + i;
                                var radioBtn = '<div class="floatLeft marginLeft10 marginRight10"><input type="radio" id="' + adhesiveSide + '" name="ink" tabindex="0" value="' + AdhSideOptions[i] + '"';

                                // Set up the selected option, the first option by default if the item is not being edited
                                if ((editID > 0 && AdhSideOptions[i] == EditAdhSideValue) || (editID <= 0 && i == 0)) {
                                    radioBtn += ' checked';
                                }

                                radioBtn += ' />';

                                radioBtn += '<label for="' + adhesiveSide + '" name="' + AdhSideOptions[i] + '">' + AdhSideOptions[i] + '</label><input type="hidden" value="' + AdhesiveSideIDs[i] + '" /></div>';

                                $('#adhSideOptions').append(radioBtn);
                            }
                            $('.PD_AdhesiveSide').show();
                            $('#adhSideOptions input').bind('click', adhesiveOptionChanged); // Bind the handler to the new radio buttons

                        } else {
                            $('.PD_AdhesiveSide').hide();
                        }

                        if (adhSidesOptions.adhesive.length > 0 && (AdhesiveOptions.length > 1 || AdhSideOptions.length > 1)) {
                            // If there is a nib or color selection to be made, set the default selections into the hidden input
                            // Edit mode implications?
                            //$('#' + adhesiveInput).val(adhSidesOptions.adhesive[0].id);
                            adhesiveOptionChanged();
                            // Do the initial pass on the ink colors to make sure only the available ones are displayed
                            toggleAvailableAdhesiveSides();
                        }
                    } else {
                        $('.PD_Adhesive').hide();
                        $('.PD_AdhesiveSide').hide();
                    }
                },
                error: function () {
                    $('.PD_Adhesive').hide();
                    $('.PD_AdhesiveSide').hide();
                }
            });
        }
    }

    function adhesiveOptionChanged() {
        toggleAvailableAdhesiveSides();

        // Find the selected nib and ink color in the master list and set the id to the hidden input
        var selectedAdhesive = $('#adhesiveOptions input:checked').val();
        var selectedAdhSide = $('#adhSideOptions input:checked').val();

        for (var i = 0; i < adhSidesOptions.adhesive.length; i++) {
            if ((selectedAdhSide == adhSidesOptions.adhesive[i].side && selectedAdhesive == adhSidesOptions.adhesive[i].adh) ||
                (typeof selectedAdhSide == 'undefined' && selectedAdhesive == adhSidesOptions.adhesive[i].adh) ||
                (selectedAdhSide == adhSidesOptions.adhesive[i].side && typeof selectedAdhesive == 'undefined')) {
                $('#adhSideOptions').find('input:checked').siblings('input').val(adhSidesOptions.adhesive[i].id);
                return;
            }
        }
    }

    function toggleAvailableAdhesiveSides() {
        // Need to hide ink colors that are not available for the selected nib size
        var selectedAdh = $('#adhesiveOptions input:checked').val();

        // Don't bother unless there are nib options and there are ink options set
        if (typeof selectedAdh != 'undefined' && adhSidesOptions.adhesive.length > 0) {
            var adhSideOptions = $('#adhSideOptions span');
            if (adhSideOptions.length > 0) {
                var selectedAdhesiveSides = new Array();

                // Populate the array with all of the possible ink colors for this nib
                for (var i = 0; i < adhSidesOptions.adhesive.length; i++) {
                    if (selectedAdh == adhSidesOptions.adhesive[i].adh) {
                        selectedAdhesiveSides[selectedAdhesiveSides.length] = adhSidesOptions.adhesive[i];
                    }
                }

                // Toggle the side options
                for (var i = 0; i < selectedAdhesiveSides.length; i++) {
                    var sideFound = false;

                    for (var j = 0; j < adhSideOptions.length; j++) {
                        if (!sideFound && $(selectedAdhesiveSides[i]).attr('name') == adhSideOptions[j].adh) { colorFound = true; }
                    }

                    if (colorFound) {
                        $(adhSideOptions[i]).show();
                    } else {
                        $(adhSideOptions[i]).hide();

                        // If the option being hidden is checked, move the option to the first visible ink option
                        if ($(adhSideOptions[i]).children('input').is(':checked')) $('#adhSideOptions span:visible input').eq(0).attr('checked', 'checked');
                    }
                }
            }
        }
    }
    //end adhesive section

    //load nib and ink color
    function LoadNibInkColor() {
        var selectedColorID = selBaseTrim.val();
        if (selectedColorID != undefined && selectedColorID != "") {
            $.ajax({
                type: "POST",
                url: "/product/nibinkcolor.aspx",
                data: { 'ProductID': prodID, 'Color': selectedColorID, 'EditID': editID },
                dataType: "html",
                timeout: 15000,
                success: function (data) {
                    nibInkOptions = data;
                    var parsedData = $.parseJSON(data);
                    if (parsedData != null && parsedData.inknib.length > 0) {
                        nibInkOptions = parsedData; // Set to the global object for use when the user is making selections

                        var NibOptions = new Array();
                        var ColorOptions = new Array();
                        var ProductColorAttributeIDs = new Array();

                        var EditNibValue = '';
                        var EditInkColorValue = '';

                        for (var i = 0; i < parsedData.inknib.length; i++) {
                            var optionFound = false;

                            // Look to see if the option has already been added to the nib option array
                            for (var j = 0; j < NibOptions.length; j++) {
                                if (!optionFound && NibOptions[j] == parsedData.inknib[i].nib) {
                                    optionFound = true;
                                }
                            }

                            // if the nib option was not found, add the option to the array for display
                            if (!optionFound) {
                                NibOptions[NibOptions.length] = parsedData.inknib[i].nib;
                            } else {
                                optionFound = false;    // Reset the variable for the color check
                            }

                            // Look to see if the option has already been added to the color option array
                            for (var j = 0; j < ColorOptions.length; j++) {
                                if (!optionFound && ColorOptions[j] == parsedData.inknib[i].ink) {
                                    optionFound = true;
                                }
                            }

                            // if the nib option was not found, add the option to the array for display
                            if (!optionFound) {
                                ColorOptions[ColorOptions.length] = parsedData.inknib[i].ink;
                                ProductColorAttributeIDs[ProductColorAttributeIDs.length] = parsedData.inknib[i].id;
                            }

                            if (editID > 0) {
                                if (parsedData.inknib[i].id == nibInkInput.val()) {
                                    EditInkColorValue = parsedData.inknib[i].ink;
                                    EditNibValue = parsedData.inknib[i].nib;
                                }
                            }
                        }

                        // All color and nib options have been located, now display them if there's more than 1
                        if (NibOptions.length > 0) {
                            //NibOptions.sort();
                            $('#nibOptions input').unbind('click', NibInkOptionChanged); // Unbind the handler from any previous radio buttons
                            $('#nibOptions').html(''); // Remove any previously displayed radio buttons
                            for (var i = 0; i < NibOptions.length; i++) {
                                var inputId = "nib" + i;
                                var radioBtn = '<div class="floatLeft marginLeft10 marginRight10"><input type="radio" id="' + inputId + '" name="nib" tabindex="0" value="' + NibOptions[i] + '"';

                                // Set up the selected option, the first option by default if the item is not being edited
                                if ((editID > 0 && NibOptions[i] == EditNibValue) || (editID <= 0 && i == 0)) {
                                    radioBtn += ' checked';
                                }

                                radioBtn += ' />';

                                radioBtn += '<label for="' + inputId + '" name="' + ColorOptions[i] + '">' + NibOptions[i] + '</label></div>';

                                $('#nibOptions').prepend(radioBtn);
                            }
                            $('.PD_NibSize').show();
                            $('#nibOptions input').bind('click', NibInkOptionChanged); // Bind the handler to the new radio buttons
                        } else {
                            $('.PD_NibSize').hide();
                        }

                        if (ColorOptions.length > 0) {
                            //ColorOptions.sort();
                            //ProductColorAttributeIDs.sort();
                            $('#inkColorOptions input').unbind('click', NibInkOptionChanged); // Unbind the handler from any previous radio buttons
                            $('#inkColorOptions').html(''); // Remove any previously displayed options
                            for (var i = 0; i < ColorOptions.length; i++) {
                                var inkId = "ink" + i;
                                var radioBtn = '<div class="floatLeft marginLeft10 marginRight10"><input type="radio" id="' + inkId + '" name="ink" tabindex="0" value="' + ColorOptions[i] + '"';

                                // Set up the selected option, the first option by default if the item is not being edited
                                if ((editID > 0 && ColorOptions[i] == EditInkColorValue) || (editID <= 0 && i == 0)) {
                                    radioBtn += ' checked';
                                }

                                radioBtn += ' />';

                                //radioBtn += '<label for="' + inkId + '" name="' + ColorOptions[i] + '">' + ColorOptions[i] + '</label><input type="hidden" tabindex="0" value="' + ProductColorAttributeIDs[i] + '" /></div>';
                                //Allows the hidden input to be assigned a class so the value can be updated via javascript
                                var colorName = "colorName" + ColorOptions[i];
                                radioBtn += '<label for="' + inkId + '" name="' + ColorOptions[i] + '">' + ColorOptions[i] + '</label><input class="' + colorName + '"type="hidden" tabindex="0" value="' + ProductColorAttributeIDs[i] + '" /></div>';

                                $('#inkColorOptions').append(radioBtn);
                            }
                            $('.PD_InkColor').show();
                            $('#inkColorOptions input').bind('click', NibInkOptionChanged); // Bind the handler to the new radio buttons

                            if (NibOptions.length < 2) {
                                // The nib section is not shown, but the ink color section is, so the step number needs to be changed. Take the number from nib section.
                                $('.PD_InkColor .PD_ChoiceHeading_Num').html($('.PD_NibSize .PD_ChoiceHeading_Num').html());
                            }
                        } else {
                            $('.PD_InkColor').hide();
                        }

                        if (nibInkOptions.inknib.length > 0 && (NibOptions.length > 1 || ColorOptions.length > 1)) {
                            // If there is a nib or color selection to be made, set the default selections into the hidden input
                            // Edit mode implications?
                            NibInkOptionChanged();

                            // Do the initial pass on the ink colors to make sure only the available ones are displayed
                            toggleAvailableInkColors();
                        }
                    } else {
                        $('.PD_NibSize').hide();
                        $('.PD_InkColor').hide();
                    }
                },
                error: function () {
                    $('.PD_NibSize').hide();
                    $('.PD_InkColor').hide();
                }
            });
        }
    }

    function NibInkOptionChanged() {
        toggleAvailableInkColors();

        // Find the selected nib and ink color in the master list and set the id to the hidden input
        var selectedInk = $('#inkColorOptions input:checked').val();
        var selectedNib = $('#nibOptions input:checked').val();

        for (var i = 0; i < nibInkOptions.inknib.length; i++) {
            if ((selectedInk == nibInkOptions.inknib[i].ink && selectedNib == nibInkOptions.inknib[i].nib) ||
                (typeof selectedInk == 'undefined' && selectedNib == nibInkOptions.inknib[i].nib) ||
                (selectedInk == nibInkOptions.inknib[i].ink && typeof selectedNib == 'undefined')) 
            {
                //console.log("pre change check");
                nibInkInput.val(nibInkOptions.inknib[i].id);
                //Update the hidden input that holds the value to properly match the nib type selected.
                $('.colorName' + nibInkOptions.inknib[i].ink).val(nibInkOptions.inknib[i].id);
                return;
            }
        }
    }

    function toggleAvailableInkColors() {
        // Need to hide ink colors that are not available for the selected nib size
        var selectedNib = $('#nibOptions input:checked').val();

        // Don't bother unless there are nib options and there are ink options set
        if (typeof selectedNib != 'undefined' && nibInkOptions.inknib.length > 0) {
            var inkOptions = $('#inkColorOptions div');
            if (inkOptions.length > 0) {
                var nibInkColors = new Array();

                // Populate the array with all of the possible ink colors for this nib
                for (var i = 0; i < nibInkOptions.inknib.length; i++) {
                    if (selectedNib == nibInkOptions.inknib[i].nib) {
                        nibInkColors[nibInkColors.length] = nibInkOptions.inknib[i];
                    }
                }

                // Toggle the ink colors
                for (var i = 0; i < inkOptions.length; i++) {
                    var colorFound = false;

                    for (var j = 0; j < nibInkColors.length; j++) {
                        if (!colorFound && $(inkOptions[i]).children('label').first().attr('name') == nibInkColors[j].ink) { colorFound = true; }
                    }

                    if (colorFound) {
                        $(inkOptions[i]).show();
                    } else {
                        $(inkOptions[i]).hide();

                        // If the option being hidden is checked, move the option to the first visible ink option
                        if ($(inkOptions[i]).children('input').is(':checked')) $('#inkColorOptions div:visible input').eq(0).attr('checked', 'checked');
                    }
                }
            }
        }
    }//end nib and ink color events


    //Delete selected imprint color
    function DeleteImprintColor(triggerElement) {
        ///<summary>Called after clicking delete all colors button, removes any additional imprint color</summary>
        ///<param name="triggerElement">The imprint location in focus</param>
        $(triggerElement).siblings('.selectedColor').css("backgroundColor", "rgba(0, 0, 0, 0)");
        $(triggerElement).siblings('.selectedColor').children('img').prop({'alt': 'Please select a "' + localizedJS.Color + '" from the "' + localizedJS.Color + '" picker', 'title': 'Please select a "' + localizedJS.Color + '" from the "' + localizedJS.Color + '" picker'});
        ResetImprintCharges();
        ValidateCustomizeSections();
    }

    function ClearImprintColors(triggerElement) {
        ///<summary>Called after clicking delete all colors button, removes any additional imprint color</summary>
        ///<param name="triggerElement">The imprint location in focus</param>
        $(triggerElement).parent().siblings('.colorList').not('.colorList:first').remove();
        $(triggerElement).parent().siblings('.colorList').first().find('.selectedColor').removeAttr('style');
        $(triggerElement).parent().siblings('.colorList').first().find('.selectedColor').children('img').prop({'alt': 'Please select a "' + localizedJS.Color + '" from the "' + localizedJS.Color + '" picker', 'title': 'Please select a "' + localizedJS.Color + '" from the "' + localizedJS.Color + '" picker'});
        ResetImprintCharges();
        ValidateCustomizeSections();
        $('.addColors').show();
        $('.moreImprintColors').show();
        $('.PD_ImprintColorChip').first().find('.spnColorChip').focus();
    }

    function CheckImprints() {
        var count = 0;
        $('.chkbxImprintLocation').each(function () {
            if ($(this).is(':checked')) {
                count++;
            }
        });

        if (count > 0) { return true; }

        return false;
    }

    function CheckImprintColors() {
        $('.chkbxImprintLocation').each(function () {
            var count = 0;
            if ($(this).is(':checked')) {
                count = 0;
                var imprintLocationID = $(this).siblings('.imprintLocationID').val();
                $('.' + imprintLocationID).children('.colorList').each(function () {

                    if ($(this).children('.selectedColor').css('backgroundColor') != "rgba(0, 0, 0, 0)") {
                        count += 1;
                    }
                });
            }
            if (count == 0) {
                $(this).attr('checked', false);
            }
        });

        $(".imprint-colors-content").fadeOut("slow", function () { });
        return CheckImprints();
    }

    function GetSelectedImprintColors() {
        listSelectedColors = [];
        listSelectedColorsRGB = [];
        listSelectedImprintLocationName = [];
        var colorIDs = [];
        var colorRGBs = [];
        $('.chkbxImprintLocation').each(function () {
            if ($(this).prop('checked')) {
                var colorsList = $(this).parent().siblings('.imprint-colors-content').find('.colorList');
                colorIDs = [];
                colorRGBs = [];
                $(colorsList).each(function () {
                    var backgroundColor = $(this).find('.selectedColor').css('backgroundColor');
                    if (backgroundColor != "rgba(0, 0, 0, 0)" && backgroundColor != 'transparent') {
                        colorIDs.push($(this).find('.imprintColorID').val());
                        colorRGBs.push(backgroundColor);
                    }
                });
                if (colorIDs.length > 0) {
                    listSelectedColors.push(colorIDs);
                }
                if (colorRGBs.length > 0) {
                    listSelectedColorsRGB.push(colorRGBs);
                    listSelectedImprintLocationName.push($(this).siblings('.imprintLocationName').val());
                }
            }
        });
    }

    //add to ~~wishlist~~ favorites
    // add to favorites
    // mm this will basically be duplicated for product-list. probably should refactor out into a favorites-specific script
    // mm originally from detailsmvc2016.js, copied to paginationTEST.js for product-list project
    function AddToWishlist() {
	
        if ($('.addToWishlist').hasClass('textRed')) {
            $('.addToWishlist').removeClass('textRed').addClass('textDkGray');
            $("#faveLink").attr("title", "Click to add this to your favorites"); // poof!
            // console.log('remove lines');
        }
        else {
            $('.addToWishlist').addClass('textRed').removeClass('textDkGray');
            $("#faveLink").attr("title", "Click to remove from your favorites"); // bam!
            // console.log('add lines');
        }
        var data = { catalogAlias: catAlias };
        $('.wishlistMsg').remove(); // doesn't seem to do anything, tho
        
        $.ajax({
            url: "/productmvc/addtowishlist",
            type: "POST",
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
               console.log(''); //
            }
        });        
    }
    //end add to wishlist

    //sample request
    function SampleRequest() {
        $('.sampleError').remove();
        $('.sampleCancel').remove();
        
        var data = { productName: $('#ProductName').val(), catalogAlias: catAlias };
        $.ajax({
            url: "/productmvc/samplerequest",
            type: "POST",
            data: JSON.stringify(data),
            beforeSend: function (req) {
                $('#imgSampleReq1Loading').fadeIn('fast');
            },
            complete: function (req) {
                $('#imgSampleReq1Loading').fadeOut('fast');
            },
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                //If the user is able to place a sample request display the sample request form otherwise let them know when they are not able to.
                if (result.Status == 'success') {
                    $('#samplePanel').hide();
                    $('#samplePanel').html(result.HtmlString).slideDown("slow", function () { });
                    $('input').removeClass('input-validation-error');
                    $('select').removeClass('input-validation-error');
                    ScrollToElement('#SampleRequestForm');
                    $('#FirstName').focus();
                    $('#btnSubmitSampleReq').click(function () { SubmitSampleRequest(); });
                }else {
                    $('.sampleRequestPanel').after(result.HtmlString);
                }
            }
        });
    }

    function SubmitSampleRequest() {
    	 
    	 	
        var formValid = true;
        $('.ErrorMsgPanel').remove();
        $('.infoText').first().after('<div class="ErrorMsgPanel text12 validation-summary-errors textDkRed hide" id="ErrorBox" role="alert"><p class="paddingTop15 text14 textBold marginLeft10 validationHeading textDkRed" id="ErrorTitle">Oops! Some of the information you entered is not correct.</p><div class="padding10 textDkRed" id="ErrorMsgBox"><ul class="text14"></ul></div></div>');
        $('.txtReq').each(function () {
            var valid = true;
            if (this.value.trim() == ""  || (this.pattern != "" && this.value.search(this.pattern) < 0)) {
                formValid = false;
                valid = false;
            }
            if (!valid) {
                $(this).css("background-color", "#ffd9d9");
                $(this).attr("aria-invalid", "true");
                $('#ErrorMsgBox > ul').append('<li><a href="#' + this.id + '" tabindex="0" role="link"><span class="visually-hidden">Please Enter </span>' + this.title + '</a></li>');
            } else {
                $(this).css("background-color", "white");
                $(this).attr({
                		"aria-invalid": "false",
                		"tabindex": "-1"
                	});
            }
        });

        if (!formValid) {
            $('#ErrorBox').removeClass("hide");
            $('#btnSubmitSampleReq').blur();
	  	 $('#ErrorMsgBox > ul > li:first-child').find('a').focus();
            return formValid;
        }

        var sampleRequestFormData = {
             CatalogAlias: catAlias, FirstName: $('#FirstName').val(), LastName: $('#LastName').val(), CompanyName: $('#CompanyName').val(), Address1: $('#Address1').val(), Address2: $('#Address2').val(), City: $('#City').val(), State: $('#State').val(),
            ZipCode: $('#ZipCode').val(), PhoneNumber: $('#PhoneNumber').val(), PhoneExt: $('#PhoneExt').val(), Comments: $('#Comments').val(), Email: $('#Email').val(), ProductName: $('#ProductName').val()
        };
        if(! $('#SampleRequestForm').hasClass('submittingForm') ){
        	$('#SampleRequestForm').addClass('submittingForm');
	        $.ajax({
	            url: "/productmvc/submitsamplerequest",
	            type: "POST",
	            data: JSON.stringify(sampleRequestFormData),
	            contentType: 'application/json',
	            dataType: 'json',
	            success: function (result) {
	                if (result.success == "true" || result.success == "banned") {
	                    $('.sampleRequestPanel').after('<p class="sampleSuccess clear textsemibold marginTop10 textBlue" aria-live="polite"><span class="icon icon-checkMarkBox text14"></span> Sample request submitted.</p>');
	                }
	                else if (result.success == "maxLimit") {
	                	$('.sampleRequestPanel').after('<p class="sampleError clear textsemibold marginTop10 textRed" aria-live="polite">You have requested quite a few samples recently! For a sample of this item, or any additional samples, please contact a friendly customer service representative using the phone number at the top of the page.</p>');
	                }
	                else {
	                    $('.sampleRequestPanel').after('<p class="sampleError clear textsemibold marginTop10 textRed" aria-live="polite">There was an issue with your request.</p>');
	                }
	                CancelSampleRequest();
	                $('#FirstName').blur();
	                $('#SampleRequestForm').removeClass('submittingForm');
	            },
	            error: function(){
	            		$('.sampleRequestPanel').after('<p class="sampleError clear textsemibold marginTop10 textRed" aria-live="polite">There was an issue with your request.</p>');
	            		$('#SampleRequestForm').removeClass('submittingForm');
	            }
	        }); 
        }
    }

    function CancelSampleRequest() {
        $('#SampleRequestForm').toggle('100', function () {
            $(this).remove();
            $('#sampleReqCustomize').hide();
        });
    }

     //clear float when image section is taller than customize section
     function clearFloat(){
    		var isDesktop = $('.prodNumber').css('float') == 'none';
    		var isTabMobile = $('.prodNumber').css('float') == 'left';
     	     //add margin to push details down and floatleft
	     if (isDesktop){
		   	var imageHeight = 370 + $('.extraImgsBox').height(),
		   		infoHeight = $('.prodInfo').height(),
		   		summaryHeight = $('.prodSummary').height(),
		   		infoSummary = infoHeight + summaryHeight;
		   		
		   	if (imageHeight > infoSummary){
		   		var H = imageHeight - infoSummary;
		   		$('.prodSummary').css({'margin-bottom': H});
		   	}
	   	}
	   	//don't add the extra margin
	   	else if (isTabMobile){
	   		$('.prodSummary').css({'margin-bottom': '20px'});
	   	}
   	}
   	
   	function ByPassFullColor(){
   		$('.colorChipsCount').each(function(){
   			if($(this).val() == '1'){
   				$(this).parent().siblings('.imprint-colors-content').hide();
   				var spnColorChip =  $(this).parent().siblings('.imprint-colors-content').find('.spnColorChip').first();
   				SaveImprintColor(spnColorChip);
   			}
   		});  	
   	}
   	function MoveZoomRight(element, increment){
		var left = element.css('left');
		if(left.length > 2){
			var leftNum = + left.substring(0,left.length-2);
			if(leftNum > -401){
				leftNum = leftNum - increment;
				if(leftNum < -401){
					leftNum = -401;
				}
			}
			element.css('left', leftNum + 'px');
		}
	}
	
	
	function MoveZoomLeft(element, increment){
			var left = element.css('left');
		if(left.length > 2){
			var leftNum = + left.substring(0,left.length-2);
			if(leftNum < 0){
				leftNum = leftNum + increment;
				if(leftNum > 0){
					leftNum = 0;
				}
			}
			element.css('left', leftNum + 'px');
		}
	}
	
	function MoveZoomUp(element, increment){
			var top = element.css('top');
		if(top.length > 2){
			var topNum = + top.substring(0,top.length-2);
			if(topNum < 0){
				topNum = topNum + increment;
				if(topNum > 0){
					topNum = 0;
				}
			}
			element.css('top', topNum + 'px');
		}
	}
	
	function MoveZoomDown(element, increment){
			var top = element.css('top');
		if(top.length > 2){
			var topNum = + top.substring(0,top.length-2);
			if(topNum > -401){
				topNum = topNum - increment;
				if(topNum < -401){
					topNum = -401;
				}
			}
			element.css('top', topNum + 'px');
		}
	}
	
	function DecreaseGlideValue(){
		var curVal = +$('input#txtQty').val();
		var step = glide.SteppingQty();
		var changeStep = step;
		for(var i = 1; i < glide.BreakArray().length - 2; i++){
			if(glide.BreakArray()[i+1] >= curVal){
				var breakRange = glide.BreakArray()[i + 1] - glide.BreakArray()[i];
				changeStep = (breakRange) /100;
				changeStep = Math.round(changeStep - (Math.round((breakRange) / changeStep % 1) - (breakRange) / changeStep % 1) * changeStep);
				if(changeStep % step != 0){
					changeStep = Math.floor(changeStep / step + 1) * step;
				}
				break;
			}
		}
		if(changeStep < 1){
			changeStep = step;
		}
		var newVal = curVal - changeStep;
		if(newVal < glide.MinBreakQty()){
			newVal = glide.MinBreakQty();
		}
		$("#GlideSlider").sliderglide("value", glide.SetSlideQty(newVal));
	}
	
	function IncreaseGlideValue(){
		var curVal = +$('input#txtQty').val();
		var step = glide.SteppingQty();
		var changeStep = step;
		for(var i = 1; i < glide.BreakArray().length - 2; i++){
			if(glide.BreakArray()[i+1] > curVal){
				var breakRange = glide.BreakArray()[i + 1] - glide.BreakArray()[i];
				changeStep = (breakRange) /100;
				changeStep = Math.round(changeStep - (Math.round((breakRange) / changeStep % 1) - (breakRange) / changeStep % 1) * changeStep);
				if(changeStep % step != 0){
					changeStep = Math.floor(changeStep / step + 1) * step;
				}
				break;
			}
		}
		if(changeStep < 1){
			changeStep = step;
		}
		var newVal = curVal + changeStep;
		if(newVal > glide.MaxBreakQty()){
			newVal = glide.MaxBreakQty();
		}
		$("#GlideSlider").sliderglide("value", glide.SetSlideQty(newVal));
	
	}
   	//accessibility code
   	function catchKeyPress(e){
		var keyCode = e.keyCode || e.which;
		var view360 = $('#PD_360Flyout').css('display') == 'block';
		var guarantee360 = $('#div360dialog').css('display') == 'block';
		var glide = $('.jslider-pointer')[0] === document.activeElement;
		var zoomFocused = false;
		var zoomElement = null;
		var zoomMoveIncrement = 20;
		$('.DetailsProdImg').each(
			function(index, element){ 
				if($(this)[0] === document.activeElement)
				{ 
					zoomElement = $(this).find('.zoomWrapperImage > img')
					zoomFocused = true;
				} 
			}
		);
		if(zoomFocused){
			if(keyCode == 37){//left
				e.preventDefault();
				MoveZoomLeft(zoomElement, zoomMoveIncrement);
			}else if(keyCode == 38){//up
				e.preventDefault();
				MoveZoomUp(zoomElement, zoomMoveIncrement);
			}else if(keyCode == 39){//right
				e.preventDefault();
				MoveZoomRight(zoomElement, zoomMoveIncrement);
			}else if(keyCode == 40){//down
				e.preventDefault();
				MoveZoomDown(zoomElement, zoomMoveIncrement);
			}
		}
		if(view360){
			if(keyCode == 9){
				e.preventDefault();
				$('.PD_MagicViewClose').focus();
			}
			//left = 37
			//right = 39
			else if(keyCode == 37){
				var pos = Determine360Position();
				Set360Position(pos + 1);
			}
			else if(keyCode == 39){
				var pos = Determine360Position()
				Set360Position(pos - 1);
			}
		}else if(guarantee360){
			if(keyCode == 9){
				e.preventDefault();
				$('#hypCloseLink').focus();
			}
		}else if(glide){
			if(keyCode == 37){//left
				DecreaseGlideValue();
			}else if(keyCode == 39){//right
				IncreaseGlideValue();
			}
		}
	}
	//360view accessibility code
	var mapPos = [];
	function Get360Map(){
		if(mapPos.length == 0){
			try{
				var positions = $('#hyp360ViewZOOM').css('background-position').split(',');
				var imagePattern = /\/[0-9][0-9].jpg/;
				var images = $('#hyp360ViewZOOM').css('background-image').split(',');
				for(var i = 0; i < positions.length; i++){
					var matches = imagePattern.exec(images[i]);
					mapPos.push( +matches[0].substring(1,3) - 1);
				}
			}catch(e){}
		}
		return mapPos;
	}
	function Determine360Position(){
		try{		
			var positions = $('#hyp360ViewZOOM').css('background-position').split(',');
			
			for(var i = 0; i < positions.length; i++){
				if(positions[i].trim() == '0px 0px'){
					return Get360Map()[i];
					
				}
			}
		}
		catch(e){}
		
	}
	
	function Set360Position(position){
		try{
			var positions = $('#hyp360ViewZOOM').css('background-position').split(',');
			var pos = (position + positions.length) % positions.length;
			var bgPositions = [];
			for(var i = 0; i < positions.length; i++){
				if(Get360Map()[i] == pos){
					bgPositions.push('0px 0px');
				}else{
					bgPositions.push('0px -10000px');
				}
			}
			$('#hyp360ViewZOOM').css('background-position', bgPositions.join(', '));
	
		}catch(e){}
	}
   	
    /* ---- END NAMED LOCAL FUNCTIONS DECLARATIONS ----*/

    clearFloat();
    centerExtraImgs();
    $(window).resize(centerExtraImgs); 
    RenderToolTips();

	// EMAIL
	$('body').on('click', '.openEmail', function(){
		var Email = $('#emailPopout');
		var trigger = $(this);
		if(Email.length > 0){
			//$('.emailSent').remove();
			Email.toggle('slow');
			$('.openEmail').removeClass('bkgdLtGray').addClass('bkgdMdGray');
			return false;
		}
		else {
			$.ajax({
				url: '/product/emailus',
				type: "GET",
				contentType: 'application/json',
				beforeSend: function(){ 
					$(trigger).after('<img id="emailLoading" alt="Loading Email Request" src="//4imprintweb.blob.core.windows.net/qtzdev/core/loading2016.gif" aria-live="polite" />'); 
				},
				complete: function(){ $('#emailLoading').hide();  },
				dataType: 'html',
				success: function (result) {
					$('.contactPanel').append(result);
					$('#emailPopout').toggle('slow');
					$('.openEmail').removeClass('bkgdMdGray').addClass('bkgdLtGray');
					$('#email').focus();
				},
				error: function () {
	
				}
			});
		}
	});
	$('body').on('keypress', '.openEmail', function(e){
		if(e.which == 13){
 			$(this).click();
	 	}
	});
	
	// SUBMIT EMAIL
	$('body').on('click touch', '.submitEmail', function () {
		var filter = /^([\w-&+\']+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,66}(?:\.[a-z]{2})?)$/i;
		var email = $('#email').val();
		var questions = $('#questions').val().trim();
		var triggerElement = $(this);
		$('.ErrorMsgPanel > ul').html('');
		$('.emailSent').remove();

		var isFormValid = true;
		if (email !== "" && !filter.test(email)) {
			$('#email').css("backgroundColor", '#ffd9d9').attr("aria-invalid", "true");
			$('.ErrorMsgPanel > ul').append('<li><a href="#email" role="link" tabindex="0">Please enter a valid Email Address</a></li>');
			$('.ErrorMsgPanel').show();
			$('.ErrorMsgPanel > ul > li:first-child').find('a').focus();
			isFormValid = false;
		} else if (email === "") {
			$('#email').css("backgroundColor", '#ffd9d9').attr("aria-invalid", "true");
			$('.ErrorMsgPanel > ul').append('<li><a href="#email" role="link" tabindex="0">Please enter an Email Address</a></li>');
			$('.ErrorMsgPanel').show();
			$('.ErrorMsgPanel > ul > li:first-child').find('a').focus();
			isFormValid = false;
		} else {
			$('#email').css("backgroundColor", '#ffffff');
		}
		if (questions === "") {
			$('#questions').css("backgroundColor", '#ffd9d9').attr("aria-invalid", "true");
			$('.ErrorMsgPanel > ul').append('<li><a href="#questions" role="link" tabindex="0">Please include Question/Comments</a></li>');
			$('.ErrorMsgPanel').show();
			$('.ErrorMsgPanel > ul > li:first-child').find('a').focus();
			isFormValid = false;
		} else {
			$('#questions').css("backgroundColor", '#ffffff').attr("aria-invalid", "false");
		}

		if (!isFormValid) { return isFormValid; } else { $('.ErrorMsgPanel').hide(); }

		var data = { from: email, catalogAlias: catAlias, questions: questions , emailUS: true };
		
		if($(this).hasClass('emailYourself')){ 	data = { from: email, catalogAlias: catAlias, questions: questions , emailUS: false };	}
		
		$.ajax({
			url: '/product/submitquestions',
			type: "POST",
			datatype: 'json',
			contentType: "application/json",
			data: JSON.stringify(data),
			success: function (result) {
				if (result.success == 'true') {
					if(triggerElement.hasClass('emailYourself')){
						$('.ErrorMsgPanel').after('<div class="emailSent paddingTop15" aria-live="polite"><h3 class="text16 paddingBtm10 textBlue">Thank you!</h3><p>Your email has been sent to ' + email +'</p></div>');
					} else {
						$('.ErrorMsgPanel').after('<div class="emailSent paddingTop15" aria-live="polite"><h3 class="text16 paddingBtm10 textBlue">Thank you!</h3><p>Your email has been received. One of our customer service representatives will respond shortly.</p></div>');
					}
					$('#email').val('');
					$('#questions').val('');
					$('.cancelEmail').focus();
				} else {
					$('.ErrorMsgPanel > ul').html('').append('<li aria-live="polite">Please try again later.</li>');
					$('.ErrorMsgPanel').show();
				}
			},
			error: function () {
				$('.ErrorMsgPanel > ul').html('').append('<li aria-live="polite">Please try again later.</li>');
				$('.ErrorMsgPanel').show();
			}
		});
	});
	
	// CANCEL EMAIL
	function CancelEmail() {
		$('#emailPopout').hide('slow', function () {
			$('#emailPopout').detach();
			$('.openEmail').removeClass('bkgdLtGray').addClass('bkgdMdGray');
			$('.openEmail').after('<span class="visually-hidden" aria-live="polite">Your email request has been cancelled</span>');
			//$('.ErrorMsgPanel').hide();
			//$('#email').css("backgroundColor", '#ffffff').attr('aria-invalid', 'false');
			//$('#questions').css("backgroundColor", '#ffffff').attr('aria-invalid', 'false');
		});
	}
    
	$('body').on('click', '.cancelEmail', function(){
		CancelEmail();
	});
	$('body').on('keypress', '.cancelEmail', function(e){
		if(e.which == 13){
 			$(this).click();
	 	}
	});


    if (editID < 0) {
    	  //check first location and display imprint colors if more than one
        $('.chkbxImprintLocation').first().prop('checked', true);
        if (totalImprintColors > 0) {
            $('.chkbxImprintLocation').first().parent().siblings('.imprint-colors-content').show();
        }
    } else {
    	   //cart item is being edited.. show imprint colors for all checked imprint locations
    		if(totalImprintColors != undefined && totalImprintColors > 0){
        		$('.chkbxImprintLocation:checked').first().parent().siblings('.imprint-colors-content').show();
        } else{
        	$('.chkbxImprintLocation:checked').first().parent().siblings('.imprint-colors-content').hide();
        }
         $('.imgActive').find('.prodImgSelected').trigger("click");
    }

   //checks for full color (CYMK), or items with only 1 imprint color
   //will save imprint colors so that add to cart will be activated  - also saves the user that extra click

    
    ValidateCustomizeSections();
	
	//start royal slider
    $("#photoSwipeBox").royalSlider({
        keyboardNavEnabled: false,
        loop: true,
        //navigateByClick: false,
        autoScaleSliderHeight: 400,
        transitionSpeed: 500,
        autoScaleSlider: false,
        arrowsNav: true,
        arrowsNavAutoHide: false,
        arrowsNavHideOnTouch: false,
        autoPlay: {
            enabled: false
        },
        visibleNearby: {
            enabled: true,
            centerArea: 0.5,
            center: true,
            breakpoint: 650,
            breakpointCenterArea: 0.64,
            navigateByCenterClick: true
        }
    });
    var slider = $("#photoSwipeBox").data('royalSlider');
    
	if (slider.numSlides == 1) {
		$('.rsNav').hide();
		$('#photoSwipeBoxWrapper').css('margin', '0 auto');
	}else {
		$('#photoSwipeBoxWrapper').css('margin', '0 auto 60px auto');
	}

    $('.thumbSelectImage').each(function () {
        $('#' + this.id).click(function () {
            var vals = this.id.split('_');
            $("#photoSwipeBox").royalSlider('goTo', vals[1]);
        });
    });

    $('#leftArrowClick').click(function () {
        $("#photoSwipeBox").royalSlider('prev');
    });

    $('#rightArrowClick').click(function () {
        $("#photoSwipeBox").royalSlider('next');
    });
    
    $('.rsNav').find('.rsBullet').each(function(index) {
    		$(this).addClass('pointer');
	});
	
	//change border of slide that is currently being viewed
	slider.ev.on('rsBeforeAnimStart', function(event) {
		$('.thumbSelectImage').removeClass('borderDkGray').addClass('borderMdGray');
		// before animation between slides start
		var slideNumber = slider.currSlideId;
		 $('#thumbSelectImage_' + slideNumber).removeClass('borderMdGray').addClass('borderDkGray');
	});

	//end royal slider

    //detailsTab
    $('.detailsTabSelect').each(function () {
        $('#' + this.id).click(function () {
            $('.detailsTabSelect').removeClass('bkgdBlue textWhite').addClass('bkgdMdGray');
            $('.detailsTabSelect').attr({
            		'aria-selected': 'false',
            		'tabindex': '-1'
            	});
            $('#' + this.id).removeClass('bkgdMdGray').addClass('bkgdBlue textWhite');
            $('#' + this.id).attr({
            		'aria-selected': 'true',
            		'tabindex': '0'
            });
            $('.detailsTab').addClass('hide').hide();
            $('.detailsTab').attr('aria-hidden', 'true');
            $('.detailsTab').attr('aria-expanded', 'false');
            $('#' + this.id + 'Tab').removeClass('hide').show();
            $('#' + this.id + 'Tab').attr('aria-hidden', 'false');
            $('#' + this.id + 'Tab').attr('aria-expanded', 'true');
            $('.detailsTabArrow').removeClass('icon-arrowDownSolid').addClass('icon-arrowRightSolid');
            $('#' + this.id + 'Arrow').removeClass('icon-arrowRightSolid').addClass('icon-arrowDownSolid');
        });
    });//end detailsTab
    
    //provides keyboard accessibility to tabs
	$('.detailsTabSelect').keydown(function(ev) {
		if (ev.which ==13) {
			$(this).click();
		}
	});

    $('body').on('click touch', '.customerQuestion', function () {
        var el = $(this).siblings('.answerQuestion');
        if (el.hasClass('hide'))
        {
            el.removeClass('hide').show();
        }else{
            el.addClass('hide').hide();
        }

    });

    //positive and negative QA submit
    $('body').on('click touch', '.positiveAnswer', function () {
        var reviewID = $(this).siblings('.QA_ID').val();
        var neg = $(this).siblings('.negativeAnswer');
        var data = { answerID: reviewID, answerHelful: true,  catalogAlias: catAlias};
        $.ajax({
            url: "/product/answerhelpful",
            type: "POST",
            magic: $(this),
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                if (result.success == "true") {
                    this.magic.before('<p class=\'textBlue textsemibold reviewRemarkMsg marginBtm10\' aria-live=\'polite\'>' + result.message + '</p>');
                    neg.addClass('hide').hide();
                    this.magic.addClass('hide').hide();
                } else {
                    this.magic.before('<div class=\'clear\'></div><p class=\'textDkRed textsemibold reviewRemarkMsg marginBtm10\' role=\'alert\'>' + result.message + '</p>');
                    neg.addClass('hide').hide();
                    this.magic.addClass('hide').hide();
                }
            }
        });
    });
    $('body').on('keypress', '.positiveAnswer', function(e) {
    	if(e.which == 13){
 		$(this).click();
	 }
    });
    
    $('body').on('click touch', '.negativeAnswer', function () {
        var reviewID = $(this).siblings('.QA_ID').val();
        var pos = $(this).siblings('.positiveAnswer');

        var data = { answerID: reviewID, answerHelful: false,  catalogAlias: catAlias };
        $.ajax({
            url: "/product/answerhelpful",
            magic: $(this),
            type: "POST",
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                if (result.success == "true") {
                    this.magic.after('<div class=\'clear\'><p class=\'textBlue textsemibold reviewRemarkMsg marginTop10\' aria-live=\'polite\'>' + result.message + '</p>');
                    pos.addClass('hide').hide();
                    this.magic.addClass('hide').hide();
                } else {
                    this.magic.after('<div class=\'clear\'><p class=\'textDkRed textsemibold reviewRemarkMsg marginTop10\' role=\'alert\'>' + result.message + '</p>');
                    pos.addClass('hide').hide();
                    this.magic.addClass('hide').hide();
                }
            }
        });
    });
    $('body').on('keypress', '.negativeAnswer', function(e) {
    	if(e.which == 13){
    		$(this).click();
    	}
    });

    $('body').on('click touch', '.btnSubmitProdAnswer', function () {
        var vals = this.id.split('_');
        var question_ID = vals[1];
        var answer = $('#answerQuestion_' + question_ID);
        $('.prodAnswerMsg').remove();
        if(answer.val().trim().length < 2){
            answer.css('background-color', '#ffd9d9').attr('aria-invalid', 'true').focus();
            $('#submitAnswer_'+question_ID).parent().after('<p class=\"prodAnswerMsg clear textsemibold marginTop10 textDkRed\" role=\"alert\">' + localizedJS.InvalidAnswerMsg + '</p>');
            return false;
        } else {
            answer.css('background-color', 'transparent').removeAttr('aria-invalid');
        }
        var data = { productID: prodID, questionID: question_ID, quickAnswer: answer.val() };
        $.ajax({
            url: "/product/submitquickanswer",
            magic: $(this),
            type: "POST",
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                if (result.success == "true") {
                    this.magic.after('<div class=\'clear\'><p class=\'textBlue textsemibold prodAnswerMsg marginTop10\' aria-live=\'polite\'>' + result.message + '</p>');
                    pos.addClass('hide').hide();
                    this.magic.addClass('hide').hide();
                } else {
                    this.magic.after('<div class=\'clear\'><p class=\'textDkRed textsemibold prodAnswerMsg marginTop10\' role=\'alert\'>' + result.message + '</p>');
                    pos.addClass('hide').hide();
                    this.magic.addClass('hide').hide();
                }
            }
        });
    });


    //JQZoom stuff
    var options = {
        zoomType: 'innerzoom',
        lens: true,
        preloadImages: false,
        alwaysOn: false,
        zoomWidth: 300,
        zoomHeight: 300,
        xOffset: -80,
        yOffset: 300,
        touchEnabled: true,
        position: "top", //and MORE OPTIONS
        fadeinSpeed: 'slow',
        fadeoutSpeed: 'slow',
        title: false
    };
    
    var initLoadJQZoom = function loadJQZoom() {
        $('.DetailsProdImg').jqzoom(options);
    };
    
    var loadJQZoom = function loadJQZoom() {
        $('#hypProdImg').jqzoom(options);
    };
    
    
    var cleanJQZoom = function cleanJQZoom() {
        $('#hypProdImg').removeData('jqzoom');
    };

    initLoadJQZoom();//end JQZoom

    //fitRating
    $('.filterfitrating').each(function () {
        $('#' + this.id).click(function (e) {
            e.preventDefault();
            var vals = this.id.split('_');
            var filter = '';
            if (vals.length > 1) {
                filter = vals[1];
                $('#fitratingfilter').show();
                $('#fitratingfilter').removeClass('hide');
            }else{
                $('#fitratingfilter').hide();
                $('#fitratingfilter').addClass('hide');
            }
            loadingPage();
            $.ajax({
                url: "/productmvc/customerfitrating/" + prodID + "/1/" + filter,
                type: "GET",
                contentType: 'application/json',
                dataType: 'html',
                success: function (result) {
                    $('#customerfitcomments').html('');
                    $('#customerfitcomments').html(result);
                    hideLoading();
                    initFitRatingPages();
                    $('#fitratingfilter');
                },
                error: function(){
                		hideLoading();
                		//add error msg?
                }
            });
            return false;
        });
    });
    
    $("#fitratingfilter").on("keypress", function (e) {
    	  if (e.which == 13) {
	        var filter = '';
	        $('#fitratingfilter').hide();
	        $('#fitratingfilter').addClass('hide');
	        loadingPage();
	        $.ajax({
	            url: "/productmvc/customerfitrating/" + prodID + "/1/" + filter,
	            type: "GET",
	            contentType: 'application/json',
	            dataType: 'html',
	            success: function (result) {
	                $('#customerfitcomments').html('');
	                $('#customerfitcomments').html(result);
	                hideLoading();
	                initFitRatingPages();
	            },
	            error: function(){
	            		hideLoading();
	            		//add error msg?
	            }
	        });
        }
        return false;
    });


    initFitRatingPages();
    //end fitRating
    initQAPages();

    /*Magic360 View Activator*/
    $('#hyp360View').click(function (e) {
        e.preventDefault();
        $('#PD_360Flyout').attr('tabindex', '0').fadeIn(300, function () { });
        $('#mask360').fadeIn(300, function () { });
        $('.PD_MagicViewClose').focus();
    });

    //give 360 box appropriate class for styling
    var boxWidth = $('#PD_360Flyout').width(),
		boxHeight = $('#PD_360Flyout').height();
    if (boxWidth > boxHeight) {
        $('#PD_360Flyout').addClass('landscape');
    }
    else { $('#PD_360Flyout').addClass('portrait'); }
    
    $('.PD_MagicViewClose').click(function () {
	 $('#PD_360Flyout').attr('tabindex', '-1').fadeOut(300, function () { });
        $('#mask360').fadeOut(300, function () { });
        $('#hyp360View').focus();
    });

    $('.otherImagesJS').click(function (e) {
        e.preventDefault();
    });
    /*End Activator*/

    /*region item customization / summary*/
    $('body').on("click touch", ".nextStep", function (e) {
        $('.errorMsg').remove();
        var colorSelected = $('#colorSelected').val();
        var selectedColorID = selBaseTrim.val();
        var qty = 0;
        var priceEach = $("#lblPrice").html();
        var grandTotal = $('#lblTotal').html();
        var isApparel = $(".isApparelItem").val();
        if (isApparel == "False") {
            qty = $("#txtQty").val();
        } else {
            qty = $("#txtQty").html();
        }

        if ($(this).hasClass('step1')) {
        	ResetImprintCharges();
            if (isApparel == "True" && $('#SizingGrid').html().length > 0) {
                CalcPrice();
            }
            if (selectedColorID == undefined || selectedColorID == "") {
                if(recolorAvailable == 'True'){
                		$('.Scroller').first().before('<p class="textDkRed errorMsg padding10 borderDkRed margin20 textsemibold" role="alert">Please select a ' + localizedJS.Color + ' option from the list provided</p>');
               		$('.Scroller').find('.imgBox').first().focus();
               } else{
                		$('.PD_ColorList').before('<p class="textDkRed errorMsg padding10 borderDkRed margin20 textsemibold" role="alert">Please select a ' + localizedJS.Color + ' option from the list provided</p>');
                		$('#listView').find('.selectedImgDesc').first().focus();
                }
                ScrollToElement('.PD_Step_1');
                return false;
            }
            if (qty == NaN || qty == undefined || qty == '0' || !IsNumeric(qty)) {
                $('.qtyErrorMsg').remove();
                $('.txtApparelQty').css('background-color', '#ffd9d9').attr('aria-invalid', 'true').first().focus();
                $('input#txtQty').css('background-color', '#ffd9d9').attr('aria-invalid', 'true').focus();
                $('.pnlSelColors').after('<p class="qtyErrorMsg textDkRed errorMsg padding10 borderDkRed margin20 textsemibold" role="alert">Please enter a valid quantity. Minimum quantity for this item is ' + lowestQty + '</p>');
                ScrollToElement('.qtyErrorMsg');
                return false;
            }
            if (qty < lowestQty) {
                $('.txtApparelQty').each(function () {
                    if ($(this).val() != '') {
                        $(this).css('background-color', '#ffd9d9').attr('aria-invalid', 'true');
                    }
                });
                $('.qtyErrorMsg').remove();
                $('.pnlSelColors').after('<p class="qtyErrorMsg textDkRed errorMsg padding10 borderDkRed margin20 textsemibold" role="alert">Minimum quantity for this item is ' + lowestQty + '.</p>');
                $('input#txtQty').css('background-color', '#ffd9d9').attr('aria-invalid', 'true').focus();
                ScrollToElement('.qtyErrorMsg');
                return false;
            }
            if (qty >= lowestQty && selectedColorID != "") {
                $('.qtyErrorMsg').remove();
                $('input#txtQty').removeAttr('style').removeAttr('aria-invalid');
                $('.PD_Step_1').fadeOut('50', function () {
                    $('.PD_Step_2').fadeIn('50', function () {
                        if (optionalExtras == null) {
                            LoadOptionalExtras();
                        }
                        if (nibInkOptions == null) {
                            LoadNibInkColor();
                        }
                        if (adhSidesOptions == null) {
                            LoadAdhesiveOptions();
                        }
                        if (qryStr > 0){
                        	CheckQueryString();

                        	var gFeedSummary = '<div class="GFeedPanel1">';
                        	gFeedSummary += $('#GFeedPanel').html() + '</div>';
                        	$('#GFeedPanel').html('');

                        	if(totalImprintColors > 0){
                        		$('.chkbxImprintLocation:checked').first().parent().parent().find('.imprintButtonExtras').addClass('hide').after(gFeedSummary);
                        	} else{
                        		$('.imprintButtonExtras').addClass('hide').after(gFeedSummary);
                        	}
                        }
                        ScrollToElement('.PD_Step_2', 500);
                    });
                });
            }
        } else if ($(this).hasClass('goToStep1')) {
            $('.PD_Step_2').fadeOut('50', function () {
               var gFeedSummary = $('.GFeedPanel1').html();
                $('#GFeedPanel').html(gFeedSummary).show();
                $('.GFeedPanel1').remove();
                $('.PD_Step_1').fadeIn('50');
                ScrollToElement('.PD_Step_1',500);
            });
            e.preventDefault();
        }
    });
    /*end customization*/
    
	$('body').on("keypress", ".nextStep", function (e) {
		if(e.which == 13){
			$(this).click();
		}
	});

    $(function () {
        currencySymbol = currencySymbol.replace(/\s+/g, '');
        Glide4imprint() / GlideInit(arrBreak, arrPrice, steppingQty);
        var selectedColorID = selBaseTrim.val();
        if (selectedColorID != "") {
            $('.selectedColorID').each(function () {
                if ($(this).val() == selectedColorID) {
                    $(this).siblings('.selectedImgDesc').addClass('textWhite bkgdBlue').removeClass('colorText').children('.selectedImgOutOfStockDesc').addClass('textWhite').removeClass('textRed');
                    $(this).parent('.imgBox').addClass('imgActive');
                }
            });
        }
    });

    initReviewPages();
    initReviewFilters();
    initSuccessPages();
    
    if (localizedJS.showCustomerImages) {
    	initCustomerImagesPages();
    }
    

         //tabs keyboard accessibility
        $('.detailsTabSelect').keydown(function (e) {
            // Listen for the up, down, left and right arrow keys, otherwise, end here
            if ([37, 38, 39, 40].indexOf(e.which) == -1) {
                return;
            }
            switch (e.which) {
                case 37: // left arrow
                case 38: // up arrow
                    e.preventDefault();
                    e.stopPropagation();
                    if ($('.detailsTabSelect').first().is(':focus')) {
                        $('.detailsTabSelect').filter(':visible').last().focus().click();
                    } else {
                        $(this).prev('.detailsTabSelect').filter(':visible').focus().click();
                    }
                    break;
                case 39: // right arrow
                case 40: // down arrow
                    e.preventDefault();
                    e.stopPropagation();
                    if ($('.detailsTabSelect').filter(':visible').last().is(':focus')) {
                        $('.detailsTabSelect').first().focus().click();
                    } else {
                        $(this).next('.detailsTabSelect').filter(':visible').focus().click();
                    }
                    break;
            }
        });
	
    //positive and negative review submit
    $('body').on('click touch', '.positiveReview', function () {
    	  $('.reviewRemarkMsg').fadeOut('slow').remove();
        var reviewID = $(this).siblings('.reviewID').val();
        var data = { reportSKU: reportSKU, reviewID: reviewID, positiveReview: true, negativeReview: false, catalogAlias: catAlias };
        $.ajax({
            url: "/productmvc/reviewremark",
            type: "POST",
            magic: $(this),
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                if (result.success == "true") {
                    this.magic.before('<p class=\'clear textBlue textsemibold reviewRemarkMsg marginBtm10\' aria-live=\'polite\'>' + result.message + '</p>');
                } else {
                    this.magic.before('<p class=\'clear textDkRed textsemibold reviewRemarkMsg marginBtm10\' role=\'alert\'>' + result.message + '</p>');
                }
            }
        });       
        //$(this).off(event);
    });
    $('body').on('keypress', '.positiveReview', function (e) {
     		if(e.which == 13){
			$(this).click();
		}
     });

   $('body').on('click touch','.negativeReview', function () {
    	  $('.reviewRemarkMsg').fadeOut('slow').remove();
        var reviewID = $(this).siblings('.reviewID').val();
        var data = { reportSKU: reportSKU, reviewID: reviewID, positiveReview: false, negativeReview: true, catalogAlias: catAlias };
        $.ajax({
            url: "/productmvc/reviewremark",
            magic: $(this),
            type: "POST",
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                if (result.success == "true") {
                    this.magic.after('<div class=\'clear\'></div><p class=\'textBlue textsemibold reviewRemarkMsg marginTop10\' aria-live=\'polite\'>' + result.message + '</p>');
                } else {
                    this.magic.after('<div class=\'clear\'></div><p class=\'textDkRed textsemibold reviewRemarkMsg marginTop10\' role=\'alert\'>' + result.message + '</p>');
                }
            }
        });
    });//end positive review submit
     $('body').on('keypress','.negativeReview', function (e) {
     		if(e.which == 13){
			$(this).click();
		}
     });
    
    $('#minirating').on('mouseenter focus', function(){
            $('#ministars').fadeIn('fast');
       })
       .on('mouseleave', function(){
       	$('#ministars').fadeOut('fast');
       });
       
	$('#miniReviewLink').click( function(){
	   $('#reviewsTS').trigger('click');
        ScrollToElement('.detailsTabSelect');
        return false;
	});

    $('body').on("click touch", ".exitReadAll", function () {
        $('.viewModeAll').fadeOut('slow', function () { });
        $('.viewModeAll').remove();
        $('.halfPageContent').fadeIn('slow', function () { });
    });

    $('body').on("click touch", ".readMoreAnswers", function () {
        $('.product-moreanswers-dropdown').hide("slow", function () { });
        if ($(this).siblings('.product-moreanswers-dropdown').is(":hidden")) {
            $(this).siblings('.product-moreanswers-dropdown').slideDown("slow", function () { });
        } else {
            $(this).siblings('.product-moreanswers-dropdown').hide("slow", function () { });
        }
    });

    $('body').on("click touch", ".cancelQuickAnswer", function () {
        $('.quickAnswerContent').hide('slow', function () { });
        $('.quickAnswerContent').remove();
        $('.addQuickAnswer').show();
    });

    $('.addQuickAnswer').click(function () {
        $('.quickAnswerContent').hide('slow', function () { });
        $('.addQuickAnswer').show();
        $('.quickAnswSubmitMsg').remove();
        $('.quickAnswerContent').remove();
        $(this).after('<div class=\'quickAnswerContent\' ><textarea class=\"newQuickAnswer floatLeft\" col=\'4\', rows=\'5\'></textarea> <input value=\'Submit Answer\' type=\'button\' class=\'clear submitQuickAnswer button-md-thin text14 bkgdBlue whiteLink floatLeft\' />' +
            '<input value=\'Cancel\' type=\'button\' class=\'cancelQuickAnswer clear button-md-thin button-white-textBlue\' /></div>').hide();

        $('.quickAnswerContent').slideDown('slow', function () { });
    });

    $('body').on('click touch', '.submitQuickAnswer', function () {
        var quickAnswer = $(this).siblings('.newQuickAnswer').val();
        var questionID = $(this).parent().siblings('.questionID').val();
        var data = { productID: prodID, questionID: questionID, quickAnswer: quickAnswer };
        $('.quickAnswSubmitMsg').remove();
        $.ajax({
            url: "/productmvc/submitquickanswer",
            type: "POST",
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                $('.quickAnswerContent').html('');
                if (result.success == "true") {
                    $('.addQuickAnswer').show();
                    //display message
                    $('.quickAnswerContent').after('<span class=\"quickAnswSubmitMsg textBlue\" aria-live=\"polite\">' + result.message + '</span>');
                } else {
                    //notify user there was an error
                    $('.addQuickAnswer').show();
                    $('.quickAnswerContent').after('<span class=\"quickAnswSubmitMsg textDkRed\" role=\"alert\">' + result.message + '</span>');
                }
            }
        });
    });

    $('body').on('click touch', '.btnSubmitProdQuestion', function () {
    	  $('.prodQuestionMsg').remove();
        if ($('textarea.productQuestion').val().trim().length < 6) {
            $('.productQuestion').css("background-Color", "#ffd9d9").attr('aria-invalid', 'true');
            $('.submitQuestion').after('<p class=\"prodQuestionMsg clear textsemibold marginTop10 textDkRed\" role=\"alert\">' + localizedJS.InvalidQuestionMsg + '</p>');
            $('#prodQstn').focus();
            return false;
        } else {
            $('.productQuestion').css("background-Color", "transparent").removeAttr('aria-invalid');
        }
        var data = { catalogAlias: catAlias, productQuestion: $('textarea.productQuestion').val() };
        $('.prodQuestionMsg').remove();
        $.ajax({
            url: "/productmvc/saveproductquestion",
            type: "POST",
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                if (result.success == "true") {
                    //display message
                    $('.submitQuestion').after('<p class=\"prodQuestionMsg clear textsemibold marginTop10 textBlue\" aria-live=\"polite\">' + result.message + '</p>');
                    $('textarea.productQuestion').val('');
                } else {
                    //notify user there was an error
                    $('.submitQuestion').after('<p class=\"prodQuestionMsg clear textsemibold marginTop10 textDkRed\" role=\"alert\">' + result.message + '</p>');
                    $('#prodQstn').focus();
                }
            }
        });
    });

    //imprint location checkbox
    $('body').on("click touch", ".chkbxImprintLocation", function () {
        $('#GFeedData').hide('');
        $('.imprintButtonExtras').removeClass('hide');
        ResetImprintCharges();
        if ($(this).prop('checked') == true) {
            if (totalImprintColors > 0 && $(this).siblings('.colorChipsCount').val() != '1') {
                $(this).parent().siblings(".imprint-colors-content").fadeIn("slow", function () { });
            }
            if ($(this).siblings('.inputIsExcl').val() == "True") {
                $('.chkbxImprintLocation').not($(this)).prop('checked', false);
            } else {
                $('.chkbxImprintLocation:checked').each(function () {
                    if ($(this).siblings('.inputIsExcl').val() == "True") {
                        $(this).prop('checked', false);
                    }
                });
            }
        }
        ValidateCustomizeSections();
    });//end imprint location selection

    //glide init
    SetupGlide();

    if (!$('.PD_SelectionBox').hasClass('hide')) {
        $('.PD_SelectionPanel').slideToggle();
    }

    CheckForSingleQtyBreak();

    // Click events for the buttons
    $('.PD_QuantityBtnCell input').click(function () {
        if (!variableDefined('searchClicked') || (variableDefined('searchClicked') && searchClicked == false)) {
            SetQuantity(); return false;
        }
    });

    $('body').on("keyup focusout", ".txtApparelQty", function () {
        $('.txtApparelQty').css('background-color', '#ffffff').removeAttr('aria-invalid');
        if (IsNumeric($(this).val())) {        
    	  	$('#txtQty').siblings('input').remove();
            CalcPrice();
        } else{
        	$(this).val('');
        	$(this).focus();
        	return false;
        }
        return true;
    });

   $('body').on("click", ".addMoreSizes", function () {
   	  $('.moreSizes').fadeIn('200');
	  var newLabel = $(this).val().replace('Add', 'Clear All');
	  $(this).val(newLabel).removeClass('addMoreSizes').addClass('clearAllSizes');	  
   });	
	
    $('body').on("click", ".clearAllSizes", function () {
   	  $('.moreSizes').fadeOut('200').find('.txtApparelQty').val('');
	  var newLabel = $(this).val().replace('Clear All', 'Add');
	  $(this).val(newLabel).removeClass('clearAllSizes').addClass('addMoreSizes');
	  CalcPrice();	  
   });
	
    if(totalProductImages == 1 || editID > 0){
    	$('.step1').removeClass('disabledBtn').addClass('bkgdBlue whiteLink');
    }
    $('.sampleRequest1').click(function () { SampleRequest(); }); 
    $('body').on('click', '#cancelRequest', function(e) {
		e.preventDefault();
		CancelSampleRequest();
		$('.sampleRequestPanel').after('<p class="sampleCancel clear textsemibold marginTop10 textBlue" aria-live="polite">Your sample request has been cancelled.</p>');
    });
    $('body').on('keypress', '#cancelRequest', function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
    });
    //$('body').on('click','#cancelRequest', function () { CancelSampleRequest(); }); 
    $('.addToWishlist ').on('click', function(e) {
		e.preventDefault();
		AddToWishlist(); 
	}); 
	$('.addToWishlist ').on('keypress', function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	}); 
    $('.addColors').click(function () { UnlockMoreColors(this, totalImprintColors); });
    $('.clearAllColors').click(function () { ClearImprintColors(this); });
    $('.closeColorPicker').click(function () { CloseColorPicker(this); });
    $('.spnColorChip').click(function () { SaveImprintColor(this); });
    $('.spnColorChip').keypress(function (e) { 
    	if(e.which == 13){
 		$(this).click();
	 }
    });
    $('.calcExtrasBtn').click(function () { GetExtras(this); });
    $('.btnAddToCart').on('click touchstart', function () { AddToCart(this); });    
    $('body').on('click touchstart', '.imprintClearColor', function(){  DeleteImprintColor(this);  });
    $('.imprintClearColor').keypress(function(e){
        if(e.which == 13){
 		$(this).click();
	 }
    });
    $('#txtQty').keyup(function(){ TextUpdateSlider(this.value); });
    $('#hypMoreDetails').click(function(e){ e.preventDefault(); ScrollToElement('.prodDetails'); });    
    
    if($('.isApparelItem').val() == 'False' && qryStr > 0){
    	  $('.selectedImgDesc').first().trigger("click");
    	  CheckQueryString();
    } else if(qryStr > 0 && totalProductImages > 1){
    	  $('#GFeedPanel').hide();  	 
    	  $('.selectedImgDesc').first().trigger("click");
    }else if(qryStr > 0 && totalProductImages == 1){
        $('.txtApparelQty').first().val(lowestQty);
        CalcPrice();
        CheckQueryString();
    }
   
   // Sets the default button click for textboxes
    	$('.PD_QuantityEntryTxtBox').keypress(function(e){
    		// Quantity textbox to Next Button (imprint locations)
		if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {
			TextUpdateSliderFinish($(this).val());
			$('.PD_QuantityBtnCell input').trigger('click');
			return true;
		}
	});   
   
    if (optionalExtras == null) { LoadOptionalExtras(); }
    if (nibInkOptions == null) { LoadNibInkColor();  }
    if (adhSidesOptions == null) { LoadAdhesiveOptions();  }
    
    ByPassFullColor();
    
    $(document).ready(function () { 
        switch(window.location.hash){
        	case '#reviews':
        		$('#reviewsTS').trigger('click');
    			break;
    		case '#stories':
        		$('#successStoriesTS').trigger('click');
    			break;
    		case '#fit':
			$('#fitRatingTS').trigger('click');
			break;
		case '#questions':
			$('#QATS').trigger('click');
			break;
    		default:
    			break;
    			
        }
   	 if ($('#InfoType').length>0) { 
    		var InfoType = $('#InfoType').val();
    		switch (InfoType) {
    			case '1': 
    				$('#reviewsTS').trigger('click');
    				ScrollToElement('.detailsTabSelect');
    				break;
    			case '2':
    				$('#successStoriesTS').trigger('click');
    				ScrollToElement('.detailsTabSelect');
    				break;
    			case '3':
    				$('#fitRatingTS').trigger('click');
    				ScrollToElement('.detailsTabSelect');
    				break;
    			case '4':
    				$('#QATS').trigger('click');
    				ScrollToElement('.detailsTabSelect');
    				break;
    			default:
    				break;
    		
    		}
    	}
    });
    
    $(window).resize(clearFloat);
	$('.rsSlide > div > a').on('focus', function(){
		$(this).find('.zoomWrapperImage > img').css('top','-200px');
		$(this).find('.zoomWrapperImage > img').css('left','-200px');
		$(this).find('.zoomWindow').css('display', 'block');
	});
	$('.rsSlide > div > a').on('blur', function(){
		$(this).find('.zoomWindow').css('display', 'none');
	});
    //catch key press for accessibility
    document.onkeypress = catchKeyPress;
           
});//end js file, anything added after this will have a global scope....